/*!
 * Datepicker v1.0.10
 * https://fengyuanchen.github.io/datepicker
 *
 * Copyright 2014-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-09-29T14:46:10.983Z
 */

'use strict';

var $ = jQuery;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var $__default = /*#__PURE__*/_interopDefaultLegacy($);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var DEFAULTS = {
  // Show the datepicker automatically when initialized
  autoShow: false,
  // Hide the datepicker automatically when picked
  autoHide: false,
  // Pick the initial date automatically when initialized
  autoPick: false,
  // Enable inline mode
  inline: false,
  // A element (or selector) for putting the datepicker
  container: null,
  // A element (or selector) for triggering the datepicker
  trigger: null,
  // The ISO language code (built-in: en-US)
  language: '',
  // The date string format
  format: 'mm/dd/yyyy',
  // The initial date
  date: null,
  // The start view date
  startDate: null,
  // The end view date
  endDate: null,
  // The start view when initialized
  startView: 0,
  // 0 for days, 1 for months, 2 for years
  // The start day of the week
  // 0 for Sunday, 1 for Monday, 2 for Tuesday, 3 for Wednesday,
  // 4 for Thursday, 5 for Friday, 6 for Saturday
  weekStart: 0,
  // Show year before month on the datepicker header
  yearFirst: false,
  // A string suffix to the year number.
  yearSuffix: '',
  // Days' name of the week.
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  // Shorter days' name
  daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  // Shortest days' name
  daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  // Months' name
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  // Shorter months' name
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  // A element tag for each item of years, months and days
  itemTag: 'li',
  // A class (CSS) for muted date item
  mutedClass: 'muted',
  // A class (CSS) for picked date item
  pickedClass: 'picked',
  // A class (CSS) for disabled date item
  disabledClass: 'disabled',
  // A class (CSS) for highlight date item
  highlightedClass: 'highlighted',
  // The template of the datepicker
  template: '<div class="datepicker-container">' + '<div class="datepicker-panel" data-view="years picker">' + '<ul>' + '<li data-view="years prev">&lsaquo;</li>' + '<li data-view="years current"></li>' + '<li data-view="years next">&rsaquo;</li>' + '</ul>' + '<ul data-view="years"></ul>' + '</div>' + '<div class="datepicker-panel" data-view="months picker">' + '<ul>' + '<li data-view="year prev">&lsaquo;</li>' + '<li data-view="year current"></li>' + '<li data-view="year next">&rsaquo;</li>' + '</ul>' + '<ul data-view="months"></ul>' + '</div>' + '<div class="datepicker-panel" data-view="days picker">' + '<ul>' + '<li data-view="month prev">&lsaquo;</li>' + '<li data-view="month current"></li>' + '<li data-view="month next">&rsaquo;</li>' + '</ul>' + '<ul data-view="week"></ul>' + '<ul data-view="days"></ul>' + '</div>' + '</div>',
  // The offset top or bottom of the datepicker from the element
  offset: 10,
  // The `z-index` of the datepicker
  zIndex: 1000,
  // Filter each date item (return `false` to disable a date item)
  filter: null,
  // Event shortcuts
  show: null,
  hide: null,
  pick: null
};

var IS_BROWSER = typeof window !== 'undefined';
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
var NAMESPACE = 'datepicker';
var EVENT_CLICK = "click.".concat(NAMESPACE);
var EVENT_FOCUS = "focus.".concat(NAMESPACE);
var EVENT_HIDE = "hide.".concat(NAMESPACE);
var EVENT_KEYUP = "keyup.".concat(NAMESPACE);
var EVENT_PICK = "pick.".concat(NAMESPACE);
var EVENT_RESIZE = "resize.".concat(NAMESPACE);
var EVENT_SCROLL = "scroll.".concat(NAMESPACE);
var EVENT_SHOW = "show.".concat(NAMESPACE);
var EVENT_TOUCH_START = "touchstart.".concat(NAMESPACE);
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var LANGUAGES = {};
var VIEWS = {
  DAYS: 0,
  MONTHS: 1,
  YEARS: 2
};

var toString = Object.prototype.toString;
function typeOf(obj) {
  return toString.call(obj).slice(8, -1).toLowerCase();
}
function isString(value) {
  return typeof value === 'string';
}
var isNaN = Number.isNaN || WINDOW.isNaN;
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}
function isUndefined(value) {
  return typeof value === 'undefined';
}
function isDate(value) {
  return typeOf(value) === 'date' && !isNaN(value.getTime());
}
function proxy(fn, context) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args2[_key2] = arguments[_key2];
    }

    return fn.apply(context, args.concat(args2));
  };
}
function selectorOf(view) {
  return "[data-view=\"".concat(view, "\"]");
}
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function getDaysInMonth(year, month) {
  return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
}
function getMinDay(year, month, day) {
  return Math.min(day, getDaysInMonth(year, month));
}
var formatParts = /(y|m|d)+/g;
function parseFormat(format) {
  var source = String(format).toLowerCase();
  var parts = source.match(formatParts);

  if (!parts || parts.length === 0) {
    throw new Error('Invalid date format.');
  }

  format = {
    source: source,
    parts: parts
  };
  $__default['default'].each(parts, function (i, part) {
    switch (part) {
      case 'dd':
      case 'd':
        format.hasDay = true;
        break;

      case 'mm':
      case 'm':
        format.hasMonth = true;
        break;

      case 'yyyy':
      case 'yy':
        format.hasYear = true;
        break;
    }
  });
  return format;
}
function getScrollParent(element) {
  var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var $element = $__default['default'](element);
  var position = $element.css('position');
  var excludeStaticParent = position === 'absolute';
  var overflowRegex = includeHidden ? /auto|scroll|hidden/ : /auto|scroll/;
  var scrollParent = $element.parents().filter(function (index, parent) {
    var $parent = $__default['default'](parent);

    if (excludeStaticParent && $parent.css('position') === 'static') {
      return false;
    }

    return overflowRegex.test($parent.css('overflow') + $parent.css('overflow-y') + $parent.css('overflow-x'));
  }).eq(0);
  return position === 'fixed' || !scrollParent.length ? $__default['default'](element.ownerDocument || document) : scrollParent;
}
/**
 * Add leading zeroes to the given value
 * @param {number} value - The value to add.
 * @param {number} [length=1] - The expected value length.
 * @returns {string} Returns converted value.
 */

function addLeadingZero(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var str = String(Math.abs(value));
  var i = str.length;
  var result = '';

  if (value < 0) {
    result += '-';
  }

  while (i < length) {
    i += 1;
    result += '0';
  }

  return result + str;
}

var REGEXP_DIGITS = /\d+/g;
var methods = {
  // Show the datepicker
  show: function show() {
    if (!this.built) {
      this.build();
    }

    if (this.shown) {
      return;
    }

    if (this.trigger(EVENT_SHOW).isDefaultPrevented()) {
      return;
    }

    this.shown = true;
    this.$picker.removeClass(CLASS_HIDE).on(EVENT_CLICK, $__default['default'].proxy(this.click, this));
    this.showView(this.options.startView);

    if (!this.inline) {
      this.$scrollParent.on(EVENT_SCROLL, $__default['default'].proxy(this.place, this));
      $__default['default'](window).on(EVENT_RESIZE, this.onResize = proxy(this.place, this));
      $__default['default'](document).on(EVENT_CLICK, this.onGlobalClick = proxy(this.globalClick, this));
      $__default['default'](document).on(EVENT_KEYUP, this.onGlobalKeyup = proxy(this.globalKeyup, this));

      if (IS_TOUCH_DEVICE) {
        $__default['default'](document).on(EVENT_TOUCH_START, this.onTouchStart = proxy(this.touchstart, this));
      }

      this.place();
    }
  },
  // Hide the datepicker
  hide: function hide() {
    if (!this.shown) {
      return;
    }

    if (this.trigger(EVENT_HIDE).isDefaultPrevented()) {
      return;
    }

    this.shown = false;
    this.$picker.addClass(CLASS_HIDE).off(EVENT_CLICK, this.click);

    if (!this.inline) {
      this.$scrollParent.off(EVENT_SCROLL, this.place);
      $__default['default'](window).off(EVENT_RESIZE, this.onResize);
      $__default['default'](document).off(EVENT_CLICK, this.onGlobalClick);
      $__default['default'](document).off(EVENT_KEYUP, this.onGlobalKeyup);

      if (IS_TOUCH_DEVICE) {
        $__default['default'](document).off(EVENT_TOUCH_START, this.onTouchStart);
      }
    }
  },
  toggle: function toggle() {
    if (this.shown) {
      this.hide();
    } else {
      this.show();
    }
  },
  // Update the datepicker with the current input value
  update: function update() {
    var value = this.getValue();

    if (value === this.oldValue) {
      return;
    }

    this.setDate(value, true);
    this.oldValue = value;
  },

  /**
   * Pick the current date to the element
   *
   * @param {String} _view (private)
   */
  pick: function pick(_view) {
    var $this = this.$element;
    var date = this.date;

    if (this.trigger(EVENT_PICK, {
      view: _view || '',
      date: date
    }).isDefaultPrevented()) {
      return;
    }

    date = this.formatDate(this.date);
    this.setValue(date);

    if (this.isInput) {
      $this.trigger('input');
      $this.trigger('change');
    }
  },
  // Reset the datepicker
  reset: function reset() {
    this.setDate(this.initialDate, true);
    this.setValue(this.initialValue);

    if (this.shown) {
      this.showView(this.options.startView);
    }
  },

  /**
   * Get the month name with given argument or the current date
   *
   * @param {Number} month (optional)
   * @param {Boolean} shortForm (optional)
   * @return {String} (month name)
   */
  getMonthName: function getMonthName(month, shortForm) {
    var options = this.options;
    var monthsShort = options.monthsShort;
    var months = options.months;

    if ($__default['default'].isNumeric(month)) {
      month = Number(month);
    } else if (isUndefined(shortForm)) {
      shortForm = month;
    }

    if (shortForm === true) {
      months = monthsShort;
    }

    return months[isNumber(month) ? month : this.date.getMonth()];
  },

  /**
   * Get the day name with given argument or the current date
   *
   * @param {Number} day (optional)
   * @param {Boolean} shortForm (optional)
   * @param {Boolean} min (optional)
   * @return {String} (day name)
   */
  getDayName: function getDayName(day, shortForm, min) {
    var options = this.options;
    var days = options.days;

    if ($__default['default'].isNumeric(day)) {
      day = Number(day);
    } else {
      if (isUndefined(min)) {
        min = shortForm;
      }

      if (isUndefined(shortForm)) {
        shortForm = day;
      }
    }

    if (min) {
      days = options.daysMin;
    } else if (shortForm) {
      days = options.daysShort;
    }

    return days[isNumber(day) ? day : this.date.getDay()];
  },

  /**
   * Get the current date
   *
   * @param {Boolean} formatted (optional)
   * @return {Date|String} (date)
   */
  getDate: function getDate(formatted) {
    var date = this.date;
    return formatted ? this.formatDate(date) : new Date(date);
  },

  /**
   * Set the current date with a new date
   *
   * @param {Date} date
   * @param {Boolean} _updated (private)
   */
  setDate: function setDate(date, _updated) {
    var filter = this.options.filter;

    if (isDate(date) || isString(date)) {
      date = this.parseDate(date);

      if ($__default['default'].isFunction(filter) && filter.call(this.$element, date, 'day') === false) {
        return;
      }

      this.date = date;
      this.viewDate = new Date(date);

      if (!_updated) {
        this.pick();
      }

      if (this.built) {
        this.render();
      }
    }
  },

  /**
   * Set the start view date with a new date
   *
   * @param {Date|string|null} date
   */
  setStartDate: function setStartDate(date) {
    if (isDate(date) || isString(date)) {
      this.startDate = this.parseDate(date);
    } else {
      this.startDate = null;
    }

    if (this.built) {
      this.render();
    }
  },

  /**
   * Set the end view date with a new date
   *
   * @param {Date|string|null} date
   */
  setEndDate: function setEndDate(date) {
    if (isDate(date) || isString(date)) {
      this.endDate = this.parseDate(date);
    } else {
      this.endDate = null;
    }

    if (this.built) {
      this.render();
    }
  },

  /**
   * Parse a date string with the set date format
   *
   * @param {String} date
   * @return {Date} (parsed date)
   */
  parseDate: function parseDate(date) {
    var format = this.format;
    var parts = [];

    if (!isDate(date)) {
      if (isString(date)) {
        parts = date.match(REGEXP_DIGITS) || [];
      }

      date = date ? new Date(date) : new Date();

      if (!isDate(date)) {
        date = new Date();
      }

      if (parts.length === format.parts.length) {
        // Set year and month first
        $__default['default'].each(parts, function (i, part) {
          var value = parseInt(part, 10);

          switch (format.parts[i]) {
            case 'yy':
              date.setFullYear(2000 + value);
              break;

            case 'yyyy':
              // Converts 2-digit year to 2000+
              date.setFullYear(part.length === 2 ? 2000 + value : value);
              break;

            case 'mm':
            case 'm':
              date.setMonth(value - 1);
              break;
          }
        }); // Set day in the last to avoid converting `31/10/2019` to `01/10/2019`

        $__default['default'].each(parts, function (i, part) {
          var value = parseInt(part, 10);

          switch (format.parts[i]) {
            case 'dd':
            case 'd':
              date.setDate(value);
              break;
          }
        });
      }
    } // Ignore hours, minutes, seconds and milliseconds to avoid side effect (#192)


    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  },

  /**
   * Format a date object to a string with the set date format
   *
   * @param {Date} date
   * @return {String} (formatted date)
   */
  formatDate: function formatDate(date) {
    var format = this.format;
    var formatted = '';

    if (isDate(date)) {
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();
      var values = {
        d: day,
        dd: addLeadingZero(day, 2),
        m: month + 1,
        mm: addLeadingZero(month + 1, 2),
        yy: String(year).substring(2),
        yyyy: addLeadingZero(year, 4)
      };
      formatted = format.source;
      $__default['default'].each(format.parts, function (i, part) {
        formatted = formatted.replace(part, values[part]);
      });
    }

    return formatted;
  },
  // Destroy the datepicker and remove the instance from the target element
  destroy: function destroy() {
    this.unbind();
    this.unbuild();
    this.$element.removeData(NAMESPACE);
  }
};

var handlers = {
  click: function click(e) {
    var $target = $__default['default'](e.target);
    var options = this.options,
        date = this.date,
        viewDate = this.viewDate,
        format = this.format;
    e.stopPropagation();
    e.preventDefault();

    if ($target.hasClass('disabled')) {
      return;
    }

    var view = $target.data('view');
    var viewYear = viewDate.getFullYear();
    var viewMonth = viewDate.getMonth();
    var viewDay = viewDate.getDate();

    switch (view) {
      case 'years prev':
      case 'years next':
        {
          viewYear = view === 'years prev' ? viewYear - 10 : viewYear + 10;
          viewDate.setFullYear(viewYear);
          viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
          this.renderYears();
          break;
        }

      case 'year prev':
      case 'year next':
        viewYear = view === 'year prev' ? viewYear - 1 : viewYear + 1;
        viewDate.setFullYear(viewYear);
        viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
        this.renderMonths();
        break;

      case 'year current':
        if (format.hasYear) {
          this.showView(VIEWS.YEARS);
        }

        break;

      case 'year picked':
        if (format.hasMonth) {
          this.showView(VIEWS.MONTHS);
        } else {
          $target.siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'year');
          this.hideView();
        }

        this.pick('year');
        break;

      case 'year':
        viewYear = parseInt($target.text(), 10); // Set date first to avoid month changing (#195)

        date.setDate(getMinDay(viewYear, viewMonth, viewDay));
        date.setFullYear(viewYear);
        viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
        viewDate.setFullYear(viewYear);

        if (format.hasMonth) {
          this.showView(VIEWS.MONTHS);
        } else {
          $target.addClass(options.pickedClass).data('view', 'year picked').siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'year');
          this.hideView();
        }

        this.pick('year');
        break;

      case 'month prev':
      case 'month next':
        viewMonth = view === 'month prev' ? viewMonth - 1 : viewMonth + 1;

        if (viewMonth < 0) {
          viewYear -= 1;
          viewMonth += 12;
        } else if (viewMonth > 11) {
          viewYear += 1;
          viewMonth -= 12;
        }

        viewDate.setFullYear(viewYear);
        viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
        viewDate.setMonth(viewMonth);
        this.renderDays();
        break;

      case 'month current':
        if (format.hasMonth) {
          this.showView(VIEWS.MONTHS);
        }

        break;

      case 'month picked':
        if (format.hasDay) {
          this.showView(VIEWS.DAYS);
        } else {
          $target.siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'month');
          this.hideView();
        }

        this.pick('month');
        break;

      case 'month':
        viewMonth = $__default['default'].inArray($target.text(), options.monthsShort);
        date.setFullYear(viewYear); // Set date before month to avoid month changing (#195)

        date.setDate(getMinDay(viewYear, viewMonth, viewDay));
        date.setMonth(viewMonth);
        viewDate.setFullYear(viewYear);
        viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
        viewDate.setMonth(viewMonth);

        if (format.hasDay) {
          this.showView(VIEWS.DAYS);
        } else {
          $target.addClass(options.pickedClass).data('view', 'month picked').siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'month');
          this.hideView();
        }

        this.pick('month');
        break;

      case 'day prev':
      case 'day next':
      case 'day':
        if (view === 'day prev') {
          viewMonth -= 1;
        } else if (view === 'day next') {
          viewMonth += 1;
        }

        viewDay = parseInt($target.text(), 10); // Set date to 1 to avoid month changing (#195)

        date.setDate(1);
        date.setFullYear(viewYear);
        date.setMonth(viewMonth);
        date.setDate(viewDay);
        viewDate.setDate(1);
        viewDate.setFullYear(viewYear);
        viewDate.setMonth(viewMonth);
        viewDate.setDate(viewDay);
        this.renderDays();

        if (view === 'day') {
          this.hideView();
        }

        this.pick('day');
        break;

      case 'day picked':
        this.hideView();
        this.pick('day');
        break;
    }
  },
  globalClick: function globalClick(_ref) {
    var target = _ref.target;
    var element = this.element,
        $trigger = this.$trigger;
    var trigger = $trigger[0];
    var hidden = true;

    while (target !== document) {
      if (target === trigger || target === element) {
        hidden = false;
        break;
      }

      target = target.parentNode;
    }

    if (hidden) {
      this.hide();
    }
  },
  keyup: function keyup() {
    this.update();
  },
  globalKeyup: function globalKeyup(_ref2) {
    var target = _ref2.target,
        key = _ref2.key,
        keyCode = _ref2.keyCode;

    if (this.isInput && target !== this.element && this.shown && (key === 'Tab' || keyCode === 9)) {
      this.hide();
    }
  },
  touchstart: function touchstart(_ref3) {
    var target = _ref3.target;

    // Emulate click in touch devices to support hiding the picker automatically (#197).
    if (this.isInput && target !== this.element && !$__default['default'].contains(this.$picker[0], target)) {
      this.hide();
      this.element.blur();
    }
  }
};

var render = {
  render: function render() {
    this.renderYears();
    this.renderMonths();
    this.renderDays();
  },
  renderWeek: function renderWeek() {
    var _this = this;

    var items = [];
    var _this$options = this.options,
        weekStart = _this$options.weekStart,
        daysMin = _this$options.daysMin;
    weekStart = parseInt(weekStart, 10) % 7;
    daysMin = daysMin.slice(weekStart).concat(daysMin.slice(0, weekStart));
    $__default['default'].each(daysMin, function (i, day) {
      items.push(_this.createItem({
        text: day
      }));
    });
    this.$week.html(items.join(''));
  },
  renderYears: function renderYears() {
    var options = this.options,
        startDate = this.startDate,
        endDate = this.endDate;
    var disabledClass = options.disabledClass,
        filter = options.filter,
        yearSuffix = options.yearSuffix;
    var viewYear = this.viewDate.getFullYear();
    var now = new Date();
    var thisYear = now.getFullYear();
    var year = this.date.getFullYear();
    var start = -5;
    var end = 6;
    var items = [];
    var prevDisabled = false;
    var nextDisabled = false;
    var i;

    for (i = start; i <= end; i += 1) {
      var date = new Date(viewYear + i, 1, 1);
      var disabled = false;

      if (startDate) {
        disabled = date.getFullYear() < startDate.getFullYear();

        if (i === start) {
          prevDisabled = disabled;
        }
      }

      if (!disabled && endDate) {
        disabled = date.getFullYear() > endDate.getFullYear();

        if (i === end) {
          nextDisabled = disabled;
        }
      }

      if (!disabled && filter) {
        disabled = filter.call(this.$element, date, 'year') === false;
      }

      var picked = viewYear + i === year;
      var view = picked ? 'year picked' : 'year';
      items.push(this.createItem({
        picked: picked,
        disabled: disabled,
        text: viewYear + i,
        view: disabled ? 'year disabled' : view,
        highlighted: date.getFullYear() === thisYear
      }));
    }

    this.$yearsPrev.toggleClass(disabledClass, prevDisabled);
    this.$yearsNext.toggleClass(disabledClass, nextDisabled);
    this.$yearsCurrent.toggleClass(disabledClass, true).html("".concat(viewYear + start + yearSuffix, " - ").concat(viewYear + end).concat(yearSuffix));
    this.$years.html(items.join(''));
  },
  renderMonths: function renderMonths() {
    var options = this.options,
        startDate = this.startDate,
        endDate = this.endDate,
        viewDate = this.viewDate;
    var disabledClass = options.disabledClass || '';
    var months = options.monthsShort;
    var filter = $__default['default'].isFunction(options.filter) && options.filter;
    var viewYear = viewDate.getFullYear();
    var now = new Date();
    var thisYear = now.getFullYear();
    var thisMonth = now.getMonth();
    var year = this.date.getFullYear();
    var month = this.date.getMonth();
    var items = [];
    var prevDisabled = false;
    var nextDisabled = false;
    var i;

    for (i = 0; i <= 11; i += 1) {
      var date = new Date(viewYear, i, 1);
      var disabled = false;

      if (startDate) {
        prevDisabled = date.getFullYear() === startDate.getFullYear();
        disabled = prevDisabled && date.getMonth() < startDate.getMonth();
      }

      if (!disabled && endDate) {
        nextDisabled = date.getFullYear() === endDate.getFullYear();
        disabled = nextDisabled && date.getMonth() > endDate.getMonth();
      }

      if (!disabled && filter) {
        disabled = filter.call(this.$element, date, 'month') === false;
      }

      var picked = viewYear === year && i === month;
      var view = picked ? 'month picked' : 'month';
      items.push(this.createItem({
        disabled: disabled,
        picked: picked,
        highlighted: viewYear === thisYear && date.getMonth() === thisMonth,
        index: i,
        text: months[i],
        view: disabled ? 'month disabled' : view
      }));
    }

    this.$yearPrev.toggleClass(disabledClass, prevDisabled);
    this.$yearNext.toggleClass(disabledClass, nextDisabled);
    this.$yearCurrent.toggleClass(disabledClass, prevDisabled && nextDisabled).html(viewYear + options.yearSuffix || '');
    this.$months.html(items.join(''));
  },
  renderDays: function renderDays() {
    var $element = this.$element,
        options = this.options,
        startDate = this.startDate,
        endDate = this.endDate,
        viewDate = this.viewDate,
        currentDate = this.date;
    var disabledClass = options.disabledClass,
        filter = options.filter,
        months = options.months,
        weekStart = options.weekStart,
        yearSuffix = options.yearSuffix;
    var viewYear = viewDate.getFullYear();
    var viewMonth = viewDate.getMonth();
    var now = new Date();
    var thisYear = now.getFullYear();
    var thisMonth = now.getMonth();
    var thisDay = now.getDate();
    var year = currentDate.getFullYear();
    var month = currentDate.getMonth();
    var day = currentDate.getDate();
    var length;
    var i;
    var n; // Days of prev month
    // -----------------------------------------------------------------------

    var prevItems = [];
    var prevViewYear = viewYear;
    var prevViewMonth = viewMonth;
    var prevDisabled = false;

    if (viewMonth === 0) {
      prevViewYear -= 1;
      prevViewMonth = 11;
    } else {
      prevViewMonth -= 1;
    } // The length of the days of prev month


    length = getDaysInMonth(prevViewYear, prevViewMonth); // The first day of current month

    var firstDay = new Date(viewYear, viewMonth, 1); // The visible length of the days of prev month
    // [0,1,2,3,4,5,6] - [0,1,2,3,4,5,6] => [-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6]

    n = firstDay.getDay() - parseInt(weekStart, 10) % 7; // [-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6] => [1,2,3,4,5,6,7]

    if (n <= 0) {
      n += 7;
    }

    if (startDate) {
      prevDisabled = firstDay.getTime() <= startDate.getTime();
    }

    for (i = length - (n - 1); i <= length; i += 1) {
      var prevViewDate = new Date(prevViewYear, prevViewMonth, i);
      var disabled = false;

      if (startDate) {
        disabled = prevViewDate.getTime() < startDate.getTime();
      }

      if (!disabled && filter) {
        disabled = filter.call($element, prevViewDate, 'day') === false;
      }

      prevItems.push(this.createItem({
        disabled: disabled,
        highlighted: prevViewYear === thisYear && prevViewMonth === thisMonth && prevViewDate.getDate() === thisDay,
        muted: true,
        picked: prevViewYear === year && prevViewMonth === month && i === day,
        text: i,
        view: 'day prev'
      }));
    } // Days of next month
    // -----------------------------------------------------------------------


    var nextItems = [];
    var nextViewYear = viewYear;
    var nextViewMonth = viewMonth;
    var nextDisabled = false;

    if (viewMonth === 11) {
      nextViewYear += 1;
      nextViewMonth = 0;
    } else {
      nextViewMonth += 1;
    } // The length of the days of current month


    length = getDaysInMonth(viewYear, viewMonth); // The visible length of next month (42 means 6 rows and 7 columns)

    n = 42 - (prevItems.length + length); // The last day of current month

    var lastDate = new Date(viewYear, viewMonth, length);

    if (endDate) {
      nextDisabled = lastDate.getTime() >= endDate.getTime();
    }

    for (i = 1; i <= n; i += 1) {
      var date = new Date(nextViewYear, nextViewMonth, i);
      var picked = nextViewYear === year && nextViewMonth === month && i === day;
      var _disabled = false;

      if (endDate) {
        _disabled = date.getTime() > endDate.getTime();
      }

      if (!_disabled && filter) {
        _disabled = filter.call($element, date, 'day') === false;
      }

      nextItems.push(this.createItem({
        disabled: _disabled,
        picked: picked,
        highlighted: nextViewYear === thisYear && nextViewMonth === thisMonth && date.getDate() === thisDay,
        muted: true,
        text: i,
        view: 'day next'
      }));
    } // Days of current month
    // -----------------------------------------------------------------------


    var items = [];

    for (i = 1; i <= length; i += 1) {
      var _date = new Date(viewYear, viewMonth, i);

      var _disabled2 = false;

      if (startDate) {
        _disabled2 = _date.getTime() < startDate.getTime();
      }

      if (!_disabled2 && endDate) {
        _disabled2 = _date.getTime() > endDate.getTime();
      }

      if (!_disabled2 && filter) {
        _disabled2 = filter.call($element, _date, 'day') === false;
      }

      var _picked = viewYear === year && viewMonth === month && i === day;

      var view = _picked ? 'day picked' : 'day';
      items.push(this.createItem({
        disabled: _disabled2,
        picked: _picked,
        highlighted: viewYear === thisYear && viewMonth === thisMonth && _date.getDate() === thisDay,
        text: i,
        view: _disabled2 ? 'day disabled' : view
      }));
    } // Render days picker
    // -----------------------------------------------------------------------


    this.$monthPrev.toggleClass(disabledClass, prevDisabled);
    this.$monthNext.toggleClass(disabledClass, nextDisabled);
    this.$monthCurrent.toggleClass(disabledClass, prevDisabled && nextDisabled).html(options.yearFirst ? "".concat(viewYear + yearSuffix, " ").concat(months[viewMonth]) : "".concat(months[viewMonth], " ").concat(viewYear).concat(yearSuffix));
    this.$days.html(prevItems.join('') + items.join('') + nextItems.join(''));
  }
};

var CLASS_TOP_LEFT = "".concat(NAMESPACE, "-top-left");
var CLASS_TOP_RIGHT = "".concat(NAMESPACE, "-top-right");
var CLASS_BOTTOM_LEFT = "".concat(NAMESPACE, "-bottom-left");
var CLASS_BOTTOM_RIGHT = "".concat(NAMESPACE, "-bottom-right");
var CLASS_PLACEMENTS = [CLASS_TOP_LEFT, CLASS_TOP_RIGHT, CLASS_BOTTOM_LEFT, CLASS_BOTTOM_RIGHT].join(' ');

var Datepicker = /*#__PURE__*/function () {
  function Datepicker(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Datepicker);

    this.$element = $__default['default'](element);
    this.element = element;
    this.options = $__default['default'].extend({}, DEFAULTS, LANGUAGES[options.language], $__default['default'].isPlainObject(options) && options);
    this.$scrollParent = getScrollParent(element, true);
    this.built = false;
    this.shown = false;
    this.isInput = false;
    this.inline = false;
    this.initialValue = '';
    this.initialDate = null;
    this.startDate = null;
    this.endDate = null;
    this.init();
  }

  _createClass(Datepicker, [{
    key: "init",
    value: function init() {
      var $this = this.$element,
          options = this.options;
      var startDate = options.startDate,
          endDate = options.endDate,
          date = options.date;
      this.$trigger = $__default['default'](options.trigger);
      this.isInput = $this.is('input') || $this.is('textarea');
      this.inline = options.inline && (options.container || !this.isInput);
      this.format = parseFormat(options.format);
      var initialValue = this.getValue();
      this.initialValue = initialValue;
      this.oldValue = initialValue;
      date = this.parseDate(date || initialValue);

      if (startDate) {
        startDate = this.parseDate(startDate);

        if (date.getTime() < startDate.getTime()) {
          date = new Date(startDate);
        }

        this.startDate = startDate;
      }

      if (endDate) {
        endDate = this.parseDate(endDate);

        if (startDate && endDate.getTime() < startDate.getTime()) {
          endDate = new Date(startDate);
        }

        if (date.getTime() > endDate.getTime()) {
          date = new Date(endDate);
        }

        this.endDate = endDate;
      }

      this.date = date;
      this.viewDate = new Date(date);
      this.initialDate = new Date(this.date);
      this.bind();

      if (options.autoShow || this.inline) {
        this.show();
      }

      if (options.autoPick) {
        this.pick();
      }
    }
  }, {
    key: "build",
    value: function build() {
      if (this.built) {
        return;
      }

      this.built = true;
      var $this = this.$element,
          options = this.options;
      var $picker = $__default['default'](options.template);
      this.$picker = $picker;
      this.$week = $picker.find(selectorOf('week')); // Years view

      this.$yearsPicker = $picker.find(selectorOf('years picker'));
      this.$yearsPrev = $picker.find(selectorOf('years prev'));
      this.$yearsNext = $picker.find(selectorOf('years next'));
      this.$yearsCurrent = $picker.find(selectorOf('years current'));
      this.$years = $picker.find(selectorOf('years')); // Months view

      this.$monthsPicker = $picker.find(selectorOf('months picker'));
      this.$yearPrev = $picker.find(selectorOf('year prev'));
      this.$yearNext = $picker.find(selectorOf('year next'));
      this.$yearCurrent = $picker.find(selectorOf('year current'));
      this.$months = $picker.find(selectorOf('months')); // Days view

      this.$daysPicker = $picker.find(selectorOf('days picker'));
      this.$monthPrev = $picker.find(selectorOf('month prev'));
      this.$monthNext = $picker.find(selectorOf('month next'));
      this.$monthCurrent = $picker.find(selectorOf('month current'));
      this.$days = $picker.find(selectorOf('days'));

      if (this.inline) {
        $__default['default'](options.container || $this).append($picker.addClass("".concat(NAMESPACE, "-inline")));
      } else {
        $__default['default'](document.body).append($picker.addClass("".concat(NAMESPACE, "-dropdown")));
        $picker.addClass(CLASS_HIDE).css({
          zIndex: parseInt(options.zIndex, 10)
        });
      }

      this.renderWeek();
    }
  }, {
    key: "unbuild",
    value: function unbuild() {
      if (!this.built) {
        return;
      }

      this.built = false;
      this.$picker.remove();
    }
  }, {
    key: "bind",
    value: function bind() {
      var options = this.options,
          $this = this.$element;

      if ($__default['default'].isFunction(options.show)) {
        $this.on(EVENT_SHOW, options.show);
      }

      if ($__default['default'].isFunction(options.hide)) {
        $this.on(EVENT_HIDE, options.hide);
      }

      if ($__default['default'].isFunction(options.pick)) {
        $this.on(EVENT_PICK, options.pick);
      }

      if (this.isInput) {
        $this.on(EVENT_KEYUP, $__default['default'].proxy(this.keyup, this));
      }

      if (!this.inline) {
        if (options.trigger) {
          this.$trigger.on(EVENT_CLICK, $__default['default'].proxy(this.toggle, this));
        } else if (this.isInput) {
          $this.on(EVENT_FOCUS, $__default['default'].proxy(this.show, this));
        } else {
          $this.on(EVENT_CLICK, $__default['default'].proxy(this.show, this));
        }
      }
    }
  }, {
    key: "unbind",
    value: function unbind() {
      var $this = this.$element,
          options = this.options;

      if ($__default['default'].isFunction(options.show)) {
        $this.off(EVENT_SHOW, options.show);
      }

      if ($__default['default'].isFunction(options.hide)) {
        $this.off(EVENT_HIDE, options.hide);
      }

      if ($__default['default'].isFunction(options.pick)) {
        $this.off(EVENT_PICK, options.pick);
      }

      if (this.isInput) {
        $this.off(EVENT_KEYUP, this.keyup);
      }

      if (!this.inline) {
        if (options.trigger) {
          this.$trigger.off(EVENT_CLICK, this.toggle);
        } else if (this.isInput) {
          $this.off(EVENT_FOCUS, this.show);
        } else {
          $this.off(EVENT_CLICK, this.show);
        }
      }
    }
  }, {
    key: "showView",
    value: function showView(view) {
      var $yearsPicker = this.$yearsPicker,
          $monthsPicker = this.$monthsPicker,
          $daysPicker = this.$daysPicker,
          format = this.format;

      if (format.hasYear || format.hasMonth || format.hasDay) {
        switch (Number(view)) {
          case VIEWS.YEARS:
            $monthsPicker.addClass(CLASS_HIDE);
            $daysPicker.addClass(CLASS_HIDE);

            if (format.hasYear) {
              this.renderYears();
              $yearsPicker.removeClass(CLASS_HIDE);
              this.place();
            } else {
              this.showView(VIEWS.DAYS);
            }

            break;

          case VIEWS.MONTHS:
            $yearsPicker.addClass(CLASS_HIDE);
            $daysPicker.addClass(CLASS_HIDE);

            if (format.hasMonth) {
              this.renderMonths();
              $monthsPicker.removeClass(CLASS_HIDE);
              this.place();
            } else {
              this.showView(VIEWS.YEARS);
            }

            break;
          // case VIEWS.DAYS:

          default:
            $yearsPicker.addClass(CLASS_HIDE);
            $monthsPicker.addClass(CLASS_HIDE);

            if (format.hasDay) {
              this.renderDays();
              $daysPicker.removeClass(CLASS_HIDE);
              this.place();
            } else {
              this.showView(VIEWS.MONTHS);
            }

        }
      }
    }
  }, {
    key: "hideView",
    value: function hideView() {
      if (!this.inline && this.options.autoHide) {
        this.hide();
      }
    }
  }, {
    key: "place",
    value: function place() {
      if (this.inline) {
        return;
      }

      var $this = this.$element,
          options = this.options,
          $picker = this.$picker;
      var containerWidth = $__default['default'](document).outerWidth();
      var containerHeight = $__default['default'](document).outerHeight();
      var elementWidth = $this.outerWidth();
      var elementHeight = $this.outerHeight();
      var width = $picker.width();
      var height = $picker.height();

      var _$this$offset = $this.offset(),
          left = _$this$offset.left,
          top = _$this$offset.top;

      var offset = parseFloat(options.offset);
      var placement = CLASS_TOP_LEFT;

      if (isNaN(offset)) {
        offset = 10;
      }

      if (top > height && top + elementHeight + height > containerHeight) {
        top -= height + offset;
        placement = CLASS_BOTTOM_LEFT;
      } else {
        top += elementHeight + offset;
      }

      if (left + width > containerWidth) {
        left += elementWidth - width;
        placement = placement.replace('left', 'right');
      }

      $picker.removeClass(CLASS_PLACEMENTS).addClass(placement).css({
        top: top,
        left: left
      });
    } // A shortcut for triggering custom events

  }, {
    key: "trigger",
    value: function trigger(type, data) {
      var e = $__default['default'].Event(type, data);
      this.$element.trigger(e);
      return e;
    }
  }, {
    key: "createItem",
    value: function createItem(data) {
      var options = this.options;
      var itemTag = options.itemTag;
      var item = {
        text: '',
        view: '',
        muted: false,
        picked: false,
        disabled: false,
        highlighted: false
      };
      var classes = [];
      $__default['default'].extend(item, data);

      if (item.muted) {
        classes.push(options.mutedClass);
      }

      if (item.highlighted) {
        classes.push(options.highlightedClass);
      }

      if (item.picked) {
        classes.push(options.pickedClass);
      }

      if (item.disabled) {
        classes.push(options.disabledClass);
      }

      return "<".concat(itemTag, " class=\"").concat(classes.join(' '), "\" data-view=\"").concat(item.view, "\">").concat(item.text, "</").concat(itemTag, ">");
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var $this = this.$element;
      return this.isInput ? $this.val() : $this.text();
    }
  }, {
    key: "setValue",
    value: function setValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var $this = this.$element;

      if (this.isInput) {
        $this.val(value);
      } else if (!this.inline || this.options.container) {
        $this.text(value);
      }
    }
  }], [{
    key: "setDefaults",
    value: function setDefaults() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      $__default['default'].extend(DEFAULTS, LANGUAGES[options.language], $__default['default'].isPlainObject(options) && options);
    }
  }]);

  return Datepicker;
}();

if ($__default['default'].extend) {
  $__default['default'].extend(Datepicker.prototype, render, handlers, methods);
}

if ($__default['default'].fn) {
  var AnotherDatepicker = $__default['default'].fn.datepicker;

  $__default['default'].fn.datepicker = function jQueryDatepicker(option) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var result;
    this.each(function (i, element) {
      var $element = $__default['default'](element);
      var isDestroy = option === 'destroy';
      var datepicker = $element.data(NAMESPACE);

      if (!datepicker) {
        if (isDestroy) {
          return;
        }

        var options = $__default['default'].extend({}, $element.data(), $__default['default'].isPlainObject(option) && option);
        datepicker = new Datepicker(element, options);
        $element.data(NAMESPACE, datepicker);
      }

      if (isString(option)) {
        var fn = datepicker[option];

        if ($__default['default'].isFunction(fn)) {
          result = fn.apply(datepicker, args);

          if (isDestroy) {
            $element.removeData(NAMESPACE);
          }
        }
      }
    });
    return !isUndefined(result) ? result : this;
  };

  $__default['default'].fn.datepicker.Constructor = Datepicker;
  $__default['default'].fn.datepicker.languages = LANGUAGES;
  $__default['default'].fn.datepicker.setDefaults = Datepicker.setDefaults;

  $__default['default'].fn.datepicker.noConflict = function noConflict() {
    $__default['default'].fn.datepicker = AnotherDatepicker;
    return this;
  };
}

/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));
/**
 * jquery.mask.js
 * @version: v1.14.16
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
      module.exports = factory(require('jquery'));
  } else {
      factory(jQuery || Zepto);
  }

}(function ($) {
  'use strict';

  var Mask = function (el, mask, options) {

      var p = {
          invalid: [],
          getCaret: function () {
              try {
                  var sel,
                      pos = 0,
                      ctrl = el.get(0),
                      dSel = document.selection,
                      cSelStart = ctrl.selectionStart;

                  // IE Support
                  if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                      sel = dSel.createRange();
                      sel.moveStart('character', -p.val().length);
                      pos = sel.text.length;
                  }
                  // Firefox support
                  else if (cSelStart || cSelStart === '0') {
                      pos = cSelStart;
                  }

                  return pos;
              } catch (e) {}
          },
          setCaret: function(pos) {
              try {
                  if (el.is(':focus')) {
                      var range, ctrl = el.get(0);

                      // Firefox, WebKit, etc..
                      if (ctrl.setSelectionRange) {
                          ctrl.setSelectionRange(pos, pos);
                      } else { // IE
                          range = ctrl.createTextRange();
                          range.collapse(true);
                          range.moveEnd('character', pos);
                          range.moveStart('character', pos);
                          range.select();
                      }
                  }
              } catch (e) {}
          },
          events: function() {
              el
              .on('keydown.mask', function(e) {
                  el.data('mask-keycode', e.keyCode || e.which);
                  el.data('mask-previus-value', el.val());
                  el.data('mask-previus-caret-pos', p.getCaret());
                  p.maskDigitPosMapOld = p.maskDigitPosMap;
              })
              .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
              .on('paste.mask drop.mask', function() {
                  setTimeout(function() {
                      el.keydown().keyup();
                  }, 100);
              })
              .on('change.mask', function(){
                  el.data('changed', true);
              })
              .on('blur.mask', function(){
                  if (oldValue !== p.val() && !el.data('changed')) {
                      el.trigger('change');
                  }
                  el.data('changed', false);
              })
              // it's very important that this callback remains in this position
              // otherwhise oldValue it's going to work buggy
              .on('blur.mask', function() {
                  oldValue = p.val();
              })
              // select all text on focus
              .on('focus.mask', function (e) {
                  if (options.selectOnFocus === true) {
                      $(e.target).select();
                  }
              })
              // clear the value if it not complete the mask
              .on('focusout.mask', function() {
                  if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                     p.val('');
                 }
              });
          },
          getRegexMask: function() {
              var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

              for (var i = 0; i < mask.length; i++) {
                  translation = jMask.translation[mask.charAt(i)];

                  if (translation) {

                      pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                      optional = translation.optional;
                      recursive = translation.recursive;

                      if (recursive) {
                          maskChunks.push(mask.charAt(i));
                          oRecursive = {digit: mask.charAt(i), pattern: pattern};
                      } else {
                          maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                      }

                  } else {
                      maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                  }
              }

              r = maskChunks.join('');

              if (oRecursive) {
                  r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                       .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
              }

              return new RegExp(r);
          },
          destroyEvents: function() {
              el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
          },
          val: function(v) {
              var isInput = el.is('input'),
                  method = isInput ? 'val' : 'text',
                  r;

              if (arguments.length > 0) {
                  if (el[method]() !== v) {
                      el[method](v);
                  }
                  r = el;
              } else {
                  r = el[method]();
              }

              return r;
          },
          calculateCaretPosition: function(oldVal) {
              var newVal = p.getMasked(),
                  caretPosNew = p.getCaret();
              if (oldVal !== newVal) {
                  var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                      newValL = newVal.length,
                      oldValL = oldVal.length,
                      maskDigitsBeforeCaret = 0,
                      maskDigitsAfterCaret = 0,
                      maskDigitsBeforeCaretAll = 0,
                      maskDigitsBeforeCaretAllOld = 0,
                      i = 0;

                  for (i = caretPosNew; i < newValL; i++) {
                      if (!p.maskDigitPosMap[i]) {
                          break;
                      }
                      maskDigitsAfterCaret++;
                  }

                  for (i = caretPosNew - 1; i >= 0; i--) {
                      if (!p.maskDigitPosMap[i]) {
                          break;
                      }
                      maskDigitsBeforeCaret++;
                  }

                  for (i = caretPosNew - 1; i >= 0; i--) {
                      if (p.maskDigitPosMap[i]) {
                          maskDigitsBeforeCaretAll++;
                      }
                  }

                  for (i = caretPosOld - 1; i >= 0; i--) {
                      if (p.maskDigitPosMapOld[i]) {
                          maskDigitsBeforeCaretAllOld++;
                      }
                  }

                  // if the cursor is at the end keep it there
                  if (caretPosNew > oldValL) {
                    caretPosNew = newValL * 10;
                  } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                      if (!p.maskDigitPosMapOld[caretPosNew])  {
                        var caretPos = caretPosNew;
                        caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                        caretPosNew -= maskDigitsBeforeCaret;
                        if (p.maskDigitPosMap[caretPosNew])  {
                          caretPosNew = caretPos;
                        }
                      }
                  }
                  else if (caretPosNew > caretPosOld) {
                      caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                      caretPosNew += maskDigitsAfterCaret;
                  }
              }
              return caretPosNew;
          },
          behaviour: function(e) {
              e = e || window.event;
              p.invalid = [];

              var keyCode = el.data('mask-keycode');

              if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                  var newVal = p.getMasked(),
                      caretPos = p.getCaret(),
                      oldVal = el.data('mask-previus-value') || '';

                  // this is a compensation to devices/browsers that don't compensate
                  // caret positioning the right way
                  setTimeout(function() {
                    p.setCaret(p.calculateCaretPosition(oldVal));
                  }, $.jMaskGlobals.keyStrokeCompensation);

                  p.val(newVal);
                  p.setCaret(caretPos);
                  return p.callbacks(e);
              }
          },
          getMasked: function(skipMaskChars, val) {
              var buf = [],
                  value = val === undefined ? p.val() : val + '',
                  m = 0, maskLen = mask.length,
                  v = 0, valLen = value.length,
                  offset = 1, addMethod = 'push',
                  resetPos = -1,
                  maskDigitCount = 0,
                  maskDigitPosArr = [],
                  lastMaskChar,
                  check;

              if (options.reverse) {
                  addMethod = 'unshift';
                  offset = -1;
                  lastMaskChar = 0;
                  m = maskLen - 1;
                  v = valLen - 1;
                  check = function () {
                      return m > -1 && v > -1;
                  };
              } else {
                  lastMaskChar = maskLen - 1;
                  check = function () {
                      return m < maskLen && v < valLen;
                  };
              }

              var lastUntranslatedMaskChar;
              while (check()) {
                  var maskDigit = mask.charAt(m),
                      valDigit = value.charAt(v),
                      translation = jMask.translation[maskDigit];

                  if (translation) {
                      if (valDigit.match(translation.pattern)) {
                          buf[addMethod](valDigit);
                           if (translation.recursive) {
                              if (resetPos === -1) {
                                  resetPos = m;
                              } else if (m === lastMaskChar && m !== resetPos) {
                                  m = resetPos - offset;
                              }

                              if (lastMaskChar === resetPos) {
                                  m -= offset;
                              }
                          }
                          m += offset;
                      } else if (valDigit === lastUntranslatedMaskChar) {
                          // matched the last untranslated (raw) mask character that we encountered
                          // likely an insert offset the mask character from the last entry; fall
                          // through and only increment v
                          maskDigitCount--;
                          lastUntranslatedMaskChar = undefined;
                      } else if (translation.optional) {
                          m += offset;
                          v -= offset;
                      } else if (translation.fallback) {
                          buf[addMethod](translation.fallback);
                          m += offset;
                          v -= offset;
                      } else {
                        p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                      }
                      v += offset;
                  } else {
                      if (!skipMaskChars) {
                          buf[addMethod](maskDigit);
                      }

                      if (valDigit === maskDigit) {
                          maskDigitPosArr.push(v);
                          v += offset;
                      } else {
                          lastUntranslatedMaskChar = maskDigit;
                          maskDigitPosArr.push(v + maskDigitCount);
                          maskDigitCount++;
                      }

                      m += offset;
                  }
              }

              var lastMaskCharDigit = mask.charAt(lastMaskChar);
              if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                  buf.push(lastMaskCharDigit);
              }

              var newVal = buf.join('');
              p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
              return newVal;
          },
          mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
            var maskDiff = options.reverse ? newVal.length - valLen : 0;
            p.maskDigitPosMap = {};
            for (var i = 0; i < maskDigitPosArr.length; i++) {
              p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
            }
          },
          callbacks: function (e) {
              var val = p.val(),
                  changed = val !== oldValue,
                  defaultArgs = [val, e, el, options],
                  callback = function(name, criteria, args) {
                      if (typeof options[name] === 'function' && criteria) {
                          options[name].apply(this, args);
                      }
                  };

              callback('onChange', changed === true, defaultArgs);
              callback('onKeyPress', changed === true, defaultArgs);
              callback('onComplete', val.length === mask.length, defaultArgs);
              callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
          }
      };

      el = $(el);
      var jMask = this, oldValue = p.val(), regexMask;

      mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

      // public methods
      jMask.mask = mask;
      jMask.options = options;
      jMask.remove = function() {
          var caret = p.getCaret();
          if (jMask.options.placeholder) {
              el.removeAttr('placeholder');
          }
          if (el.data('mask-maxlength')) {
              el.removeAttr('maxlength');
          }
          p.destroyEvents();
          p.val(jMask.getCleanVal());
          p.setCaret(caret);
          return el;
      };

      // get value without mask
      jMask.getCleanVal = function() {
         return p.getMasked(true);
      };

      // get masked value without the value being in the input or element
      jMask.getMaskedVal = function(val) {
         return p.getMasked(false, val);
      };

     jMask.init = function(onlyMask) {
          onlyMask = onlyMask || false;
          options = options || {};

          jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
          jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
          jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

          jMask = $.extend(true, {}, jMask, options);

          regexMask = p.getRegexMask();

          if (onlyMask) {
              p.events();
              p.val(p.getMasked());
          } else {
              if (options.placeholder) {
                  el.attr('placeholder' , options.placeholder);
              }

              // this is necessary, otherwise if the user submit the form
              // and then press the "back" button, the autocomplete will erase
              // the data. Works fine on IE9+, FF, Opera, Safari.
              if (el.data('mask')) {
                el.attr('autocomplete', 'off');
              }

              // detect if is necessary let the user type freely.
              // for is a lot faster than forEach.
              for (var i = 0, maxlength = true; i < mask.length; i++) {
                  var translation = jMask.translation[mask.charAt(i)];
                  if (translation && translation.recursive) {
                      maxlength = false;
                      break;
                  }
              }

              if (maxlength) {
                  el.attr('maxlength', mask.length).data('mask-maxlength', true);
              }

              p.destroyEvents();
              p.events();

              var caret = p.getCaret();
              p.val(p.getMasked());
              p.setCaret(caret);
          }
      };

      jMask.init(!el.is('input'));
  };

  $.maskWatchers = {};
  var HTMLAttributes = function () {
      var input = $(this),
          options = {},
          prefix = 'data-mask-',
          mask = input.attr('data-mask');

      if (input.attr(prefix + 'reverse')) {
          options.reverse = true;
      }

      if (input.attr(prefix + 'clearifnotmatch')) {
          options.clearIfNotMatch = true;
      }

      if (input.attr(prefix + 'selectonfocus') === 'true') {
         options.selectOnFocus = true;
      }

      if (notSameMaskObject(input, mask, options)) {
          return input.data('mask', new Mask(this, mask, options));
      }
  },
  notSameMaskObject = function(field, mask, options) {
      options = options || {};
      var maskObject = $(field).data('mask'),
          stringify = JSON.stringify,
          value = $(field).val() || $(field).text();
      try {
          if (typeof mask === 'function') {
              mask = mask(value);
          }
          return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
      } catch (e) {}
  },
  eventSupported = function(eventName) {
      var el = document.createElement('div'), isSupported;

      eventName = 'on' + eventName;
      isSupported = (eventName in el);

      if ( !isSupported ) {
          el.setAttribute(eventName, 'return;');
          isSupported = typeof el[eventName] === 'function';
      }
      el = null;

      return isSupported;
  };

  $.fn.mask = function(mask, options) {
      options = options || {};
      var selector = this.selector,
          globals = $.jMaskGlobals,
          interval = globals.watchInterval,
          watchInputs = options.watchInputs || globals.watchInputs,
          maskFunction = function() {
              if (notSameMaskObject(this, mask, options)) {
                  return $(this).data('mask', new Mask(this, mask, options));
              }
          };

      $(this).each(maskFunction);

      if (selector && selector !== '' && watchInputs) {
          clearInterval($.maskWatchers[selector]);
          $.maskWatchers[selector] = setInterval(function(){
              $(document).find(selector).each(maskFunction);
          }, interval);
      }
      return this;
  };

  $.fn.masked = function(val) {
      return this.data('mask').getMaskedVal(val);
  };

  $.fn.unmask = function() {
      clearInterval($.maskWatchers[this.selector]);
      delete $.maskWatchers[this.selector];
      return this.each(function() {
          var dataMask = $(this).data('mask');
          if (dataMask) {
              dataMask.remove().removeData('mask');
          }
      });
  };

  $.fn.cleanVal = function() {
      return this.data('mask').getCleanVal();
  };

  $.applyDataMask = function(selector) {
      selector = selector || $.jMaskGlobals.maskElements;
      var $selector = (selector instanceof $) ? selector : $(selector);
      $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
  };

  var globals = {
      maskElements: 'input,td,span,div',
      dataMaskAttr: '*[data-mask]',
      dataMask: true,
      watchInterval: 300,
      watchInputs: true,
      keyStrokeCompensation: 10,
      // old versions of chrome dont work great with input event
      useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
      watchDataMask: false,
      byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
      translation: {
          '0': {pattern: /\d/},
          '9': {pattern: /\d/, optional: true},
          '#': {pattern: /\d/, recursive: true},
          'A': {pattern: /[a-zA-Z0-9]/},
          'S': {pattern: /[a-zA-Z]/}
      }
  };

  $.jMaskGlobals = $.jMaskGlobals || {};
  globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

  // looking for inputs with data-mask attribute
  if (globals.dataMask) {
      $.applyDataMask();
  }

  setInterval(function() {
      if ($.jMaskGlobals.watchDataMask) {
          $.applyDataMask();
      }
  }, globals.watchInterval);
}, window.jQuery, window.Zepto));

(function($) {
    class FinHub_FormHelper {
      constructor (formElement) {
        this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
        this.formElement = formElement;
        this.rules = {
          required: {
            validator: (value, field) => {
              if (field.attr('type') === 'checkbox') {
                return field.prop('checked');
              }
    
              if (field.attr('type') === 'radio') {
                let selectedValueExists = field.parents('.form-item').find('input[type="radio"]:checked').length;
                return !!selectedValueExists;
              }
    
              return !!value;
            },
            errorText: this.i18n.required
          },
          requiredIfDateToVisible: {
            validator: (value, field) => {
              let dateToField = field.parents('form').find('[data-fh-name="date_to"]');
    
              if (dateToField.length && dateToField.hasClass('is-hidden')) {
                return true;
              }
    
              return !!value;
            },
            errorText: this.i18n.required
          },
          min: {
            validator: (value, range) => parseFloat(value) >= parseFloat(range),
            errorText: (range) => this.i18n.valueless + range
          },
          max: {
            validator: (value, range) => parseFloat(value) <= parseFloat(range),
            errorText: (range) => this.i18n.valuemore + range
          },
          email: {
            validator: (value) => value.indexOf('@') > 0 && value.indexOf('.') > -1,
            errorText: this.i18n.email
          },
          phone: {
            validator: (value) => (/^[\+]{0,}[0-9]{7,}$/gmi).test(value.replace(/ /gmi, '')),
            errorText: this.i18n.phone
          },
          postcode: {
            validator: (value) => typeof value === "string" && (new RegExp(/^[0-9]{2,2}\-[0-9]{3,3}$/gmi).test(value)),
            errorText: this.i18n.code
          }
        };
        this.dependencies = {};
      }
    
      formDependencies (config) {
        for (let i = 0; i < config.length; i++) {
          if (config[i].useCollection) {
            let triggerSelector = config[i].dependsOn;
            let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
            let callback = config[i].elementsToShow;
            let triggerElement = this.formElement.find(triggerSelector);
            let fieldElements = this.formElement.find('*[data-fh-name="' + fieldName + '"]');
    
            triggerElement.on('input', (e) => {
              fieldElements.addClass('is-hidden');
    
              for (let j = 0; j < fieldElements.length; j++) {
                this.resetField(fieldElements.eq(j));
              }
    
              let elementsToShow = callback($(e.target).val());
              elementsToShow.removeClass('is-hidden');
            });
          } else {
            let triggerSelector = config[i].dependsOn;
            let fieldName = config[i].field.replace(/[^a-z0-9\_\-]/gmi, '');
            let callback = config[i].showOn;
            let triggerElement = this.formElement.find(triggerSelector);
            let fieldElement = this.formElement.find('*[data-fh-name="' + fieldName + '"]');
    
            triggerElement.on('input', (e) => {
              if (callback($(e.target).val())) {
                fieldElement.removeClass('is-hidden');
              } else {
                fieldElement.addClass('is-hidden');
                this.resetField(fieldElement);
              }
            });
          }
        }
      }
    
      resetField (fieldWrapper) {
        if (fieldWrapper.find('input').length) {
          if (fieldWrapper.find('input').attr('type') === 'radio') {
            fieldWrapper.find('input').prop('checked', false);
          } else {
            fieldWrapper.find('input').val('');
          }
    
          fieldWrapper.find('input').trigger('input');
        } else if (fieldWrapper.find('select').length) {
          fieldWrapper.find('select').val('');
          fieldWrapper.find('select').trigger('input');
        } else if (fieldWrapper.find('textarea').length) {
          fieldWrapper.find('textarea').val('');
          fieldWrapper.find('textarea').trigger('input');
        }
      }
    
      formValidate () {
        // pobieramy wszystkie pole
        let fields = this.formElement.find('*[data-fh-validation]');
        let formIsValid = true;
    
        for (let i = 0; i < fields.length; i++) {
          // pomijamy ukryte pola
          if (fields.eq(i).parents('[data-fh-name]').hasClass('is-hidden')) {
            continue;
          }
    
          let fieldValue = fields.eq(i).val();
          let validationRules = fields.eq(i).attr('data-fh-validation');
          validationRules = validationRules.split('|');
          let fieldIsValid = true;
          let fieldErrorMessage = fields.eq(i).parents('.form-item').find('.validation-error');
          let formValidationErrorMessage = fields.eq(i).parents('.form-step').find('.form-validation-error');
    
          for (let j = 0; j < validationRules.length; j++) {
            let validationRule = validationRules[j];
    
            if (validationRule.indexOf(':') > -1) {
              let ruleName = validationRule.split(':')[0];
              let range = validationRule.split(':')[1];
    
              if (!this.rules[ruleName].validator(fieldValue, range)) {
                fieldIsValid = false;
                fieldErrorMessage.text(this.rules[ruleName].errorText(range));
                break;
              }
            } else {
              if (!this.rules[validationRule].validator(fieldValue, fields.eq(i))) {
                fieldIsValid = false;
                fieldErrorMessage.text(this.rules[validationRule].errorText);
                break;
              }
            }
          }
    
          if (fieldIsValid) {
            fieldErrorMessage.addClass('is-hidden');
            fieldErrorMessage.text('');
          } else {
            formIsValid = false;
            fieldErrorMessage.removeClass('is-hidden');
            fields.eq(i).one('input', () => {
              fieldErrorMessage.addClass('is-hidden');
              fieldErrorMessage.text('');
            });
            formValidationErrorMessage.removeClass('is-hidden');
            setTimeout(() => {
              formValidationErrorMessage.addClass('is-hidden');
            }, 2000);
          }
        }
    
        return formIsValid;
      }
    }
    
    /**
     * Menu script
     */
    class FinHub_Menu {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState() {
        this.win = $(window);
        this.menuWrapper = $('.site-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menu = this.menuWrapper.find('.menu-wrapper');
        this.menuItemSubmenu = this.menuWrapper.find('.has-submenu');
        this.mobileViewport = window.matchMedia("screen and (max-width: 1024px)");
      }
    
      initEvents() {
        this.menuItemSubmenu.append( "<span class='arrow'></span>" );
    
        $(window).on('scroll', () => {
          let positionY = this.win.scrollTop();
    
          if (positionY > 25 && !this.menuWrapper.hasClass('is-fixed')) {
            this.menuWrapper.addClass('is-fixed');
            return;
          }
    
          if (positionY <= 25 && this.menuWrapper.hasClass('is-fixed')) {
            this.menuWrapper.removeClass('is-fixed');
          }
        });
    
        if (this.menuIcon.length) {
          this.menuIcon.on('click', e => {
            e.preventDefault();
            this.menu.toggleClass('is-active');
            this.menuIcon.toggleClass('is-active');
            this.menu.find('.menu-item').first().find('.menu-item__link').focus();
            $(document.body).toggleClass('no-scroll');
    
            setTimeout(() => {
              this.menu.toggleClass('is-showing');
            }, 150);
          });
        }
    
        if(this.mobileViewport.matches) {
          setTimeout(() => {
            this.menuSubmenuToggle = this.menuItemSubmenu.find('.arrow');
            
            this.menuSubmenuToggle.each(function(i, item) {
              $(item).on('click', (e) => {
                e.stopPropagation();
                $(item).parent().toggleClass('is-active');
              });
            });
          }, 0);
        }
      }
    }
    
    /**
     * Tabs script
     */
    class FinHub_Tabs {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState() {
        this.tablinksWrapper = document.querySelectorAll('.tabs__tablinks');
      }
    
      initEvents() {
        if (!this.tablinksWrapper) {
          return;
        }
    
        for (let i = 0; i < this.tablinksWrapper.length; i++) {
          if (!this.tablinksWrapper[i].getAttribute('data-js-initialized')) {
            this.tablinksWrapper[i].setAttribute('data-js-initialized', true);
            let tablinks = this.tablinksWrapper[i].querySelectorAll('.tabs__tablinks-item');
    
            for (let j = 0; j < tablinks.length; j++) {
              tablinks[j].addEventListener('click', this.showTab.bind(this));
            }
          }
        }
      }
    
      showTab(e) {
        let tabID = e.target.getAttribute('data-id');
        let wrapper = e.target.parentNode.parentNode;
        let wrapperID = e.target.parentNode.parentNode.getAttribute('data-tablinks');
        let tabContent = wrapper.querySelector('.tabs__content[data-id="' + tabID + '"]');
        let tabs = wrapper.querySelectorAll('.tabs__tablinks-item');
        let content = wrapper.querySelectorAll('.tabs__content');
    
        if (tabID) {
          tabID = tabID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        if (wrapperID) {
          wrapperID = wrapperID.replace(/[^a-z0-9\-]/gmi, '');
        }
    
        for (let i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove('tabs__tablinks-item--active');
          content[i].classList.remove('tabs__content--showing');
          content[i].classList.remove('tabs__content--active');
          content[i].setAttribute('data-current-item', '0');
          if (content[i].querySelector('.product-slider__list')) {
            content[i].querySelector('.product-slider__list').style.marginLeft = '0%';
          }
          if (content[i].querySelector('.prev')) {
            content[i].querySelector('.prev').classList.add('is-disabled');
          }
        }
    
        e.target.classList.add('tabs__tablinks-item--active');
        tabContent.classList.add('tabs__content--active');
    
        setTimeout(() => {
          tabContent.classList.add('tabs__content--showing');
        }, 200);
      }
    }
    /**
     * Advisers slider script
     */
     class FinHub_AdvisersSlider {
      constructor() {
        this.initState();
        this.initEvents();
      }
    
      initState () {
        this.sliderWrapper = $('.block-advisers-slider');
        this.prevBtn = this.sliderWrapper.find('.prev');
        this.nextBtn = this.sliderWrapper.find('.next');
        this.list = this.sliderWrapper.find('.block-advisers-slider__list');
        this.items = this.list.find('.block-advisers-slider__item');
        this.currentItem = 0;
        this.itemsPerPage = 4;
        this.animationInProgress = false;
      }
    
      initEvents() {
        this.initRWD();
    
        if (this.sliderWrapper.length) {
          this.initUI();
          this.list.attr('data-count', this.items.length);
        }
      }
    
      initUI () {        
        this.swipeEffect = new Hammer(this.sliderWrapper[0]);
        this.prevBtn.addClass('is-hidden');
    
        this.prevBtn.on('click', e => {
          e.preventDefault();
    
          if (this.animationInProgress) {
            return;
          }
    
          this.currentItem--;
          this.animationInProgress = true;
    
          if (this.currentItem === 0) {
            this.prevBtn.addClass('is-hidden');
          }
    
          this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
          this.nextBtn.removeClass('is-hidden');
    
          setTimeout(() => {
              this.animationInProgress = false;
          }, 250);
        });
    
        this.nextBtn.on('click', e => {
          e.preventDefault();
    
          if (this.animationInProgress) {
            return;
          }
    
          this.currentItem++;
          this.animationInProgress = true;
    
          if (this.currentItem === (this.items.length / 2) - 1) {
            this.nextBtn.addClass('is-hidden');
          }
    
          if (this.currentItem >= this.items.length) {
            this.currentItem = (this.items.length - 1);
          }
    
          this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");
          this.prevBtn.removeClass('is-hidden');
    
          setTimeout(() => {
            this.animationInProgress = false;
          }, 250);
        });
    
        this.swipeEffect.on('swipe', ev => {
          if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
            this.nextBtn.trigger('click');
          }
    
          if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
            this.prevBtn.trigger('click');
          }
        });
      }
    
      initRWD () {
        this.desktopViewport = window.matchMedia('(min-width: 1024px)');
        this.tabletViewport = window.matchMedia('(min-width: 560px) and (max-width: 1023px)');
        this.mobileViewport = window.matchMedia('(max-width: 559px)');
        if (this.desktopViewport.matches) this.updateViewports('desktop');
        if (this.tabletViewport.matches) this.updateViewports('tablet');
        if (this.mobileViewport.matches) this.updateViewports('mobile');
        this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
        this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
        this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
    
        if (this.desktopViewport.matches) {
          this.itemsPerPage = 4;
        } else if (this.tabletViewport.matches) {
          this.itemsPerPage = 2;
        } else if (this.mobileViewport.matches) {
          this.itemsPerPage = 1;
        }
    
        this.desktopViewport.addListener(mq => {
          if (mq.matches) {
            this.setItemsPerPage(4);
          }
        });
    
        this.tabletViewport.addListener(mq => {
          if (mq.matches) {
            this.setItemsPerPage(2);
          }
        });
    
        this.mobileViewport.addListener(mq => {
          if (mq.matches) {
            this.setItemsPerPage(1);
          }
        });
      }
    
      updateViewports (type) {
        if (this.currentViewport !== type) {
          this.currentItem = 0;
          this.list.css('margin-left', "0%");
          this.currentViewport = type;
        }
      }
    
      setItemsPerPage (numberOfItems) {
        this.currentItem = 0;
        this.itemsPerPage = numberOfItems;
        this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");  
      }
    }
    /**
     * Social sharing buttons script
     */
     class FinHub_SocialSharing {
      constructor() {
        if(!$('.post-sharing').length) {
          return;
        }
        this.initPopups();
      }
      initPopups() {
        $('.post-sharing-link').each(function(i, link) {
          $(link).on('click', function(e) {
            e.preventDefault();
            window.open($(link).attr('href'), 'Share this post', 'width=500,height=400,resizable=yes').focus();
          });
        });
      }
    }
    
    /**
     * UI elements
     */
    class FinHub_UI {
      constructor() {
        this.initTranslations();
        this.initSmoothScroll();
        this.initCustomInputNumber();
        this.initOpenNewOpininForm();
        this.initOwnContributionField();
        this.initLiabilityLabelField();
        this.initCheckAllBanksCheckboxs();
        this.initOpenSendMessageForm();
        this.initshowPhone();
        this.initAdvisorOpinionHelpful();
        this.initChangeFontSize();
        this.initFocusKeyboard();
        // this.initOnchangeSelect();
        this.showSearchAdvisorForm();
        this.lastAdvisorCityRequestID = null;
      }
    
      initTranslations () {
        this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
      }
    
      initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
          ) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top - 200
              }, 1000);
            }
          }
        });
      }
    
      initCustomInputNumber () {
        let quantity = $('.quantity');
    
        quantity.each(function() {
          let spinner = $(this),
          input = spinner.find('input[type="number"]'),
          btnUp = spinner.find('.quantity-up'),
          btnDown = spinner.find('.quantity-down'),
          min = input.attr('min'),
          max = input.attr('max');
    
          btnUp.click(function() {
            let oldValue = parseFloat(input.val());
            let newVal = oldValue + 1;
    
            if (max > 0 && oldValue >= max) {
              newVal = oldValue;
            }
    
            input.val(newVal);
            input.trigger("change");
          });
    
          btnDown.click(function() {
            let oldValue = parseFloat(input.val());
            let newVal = oldValue - 1;
    
            if (oldValue <= min) {
              newVal = oldValue;
            }
    
            input.val(newVal);
            input.trigger("change");
          });
        });
      }
    
      initOpenNewOpininForm () {
        let openFormBtn = $('.advisor-opinions-open-form');
    
        if(!openFormBtn.length) {
          return
        }
    
        openFormBtn.on('click', (e) => {
          e.preventDefault();
          let addNewOpinionForm = $('.advisor-opinions-stats-form');
    
          openFormBtn.addClass('is-hidden');
          addNewOpinionForm.addClass('is-open');
        });
      }
    
      initOwnContributionField () {
        let field = $('input[name="own_contribution"]');
        let propertyValue = $('input[name="property_value"]');
        let label = $('.own-contribution-calculated-value');
        let wrapper = $('.own-contribution-wrapper');
    
        if (field.length && propertyValue.length && label.length && wrapper.length) {
          field.on('input', () => {
            let value = parseFloat(field.val());
    
            if (value >= 0 && value <= 100) {
              wrapper.removeClass('is-hidden');
              let calculatedValue = propertyValue.val() * (value / 100);
              calculatedValue = Number(calculatedValue).toFixed(2);
              label.text(calculatedValue);
            } else {
              wrapper.addClass('is-hidden');
            }
          });
    
          propertyValue.on('input', () => {
            let value = parseFloat(field.val());
    
            if (value >= 0 && value <= 100) {
              wrapper.removeClass('is-hidden');
              let calculatedValue = propertyValue.val() * (value / 100);
              calculatedValue = Number(calculatedValue).toFixed(2);
              label.text(calculatedValue);
            } else {
              wrapper.addClass('is-hidden');
            }
          });
    
          field.trigger('input');
        }
      }
    
      initLiabilityLabelField () {
        let field = $('input[name="liability_id"]');
        let instalmentAmountLabel = $('.instaltment-amount-label');
    
        if (field.length && instalmentAmountLabel.length) {
          field.change('input', (e) => {
            let fieldLabelName = $(e.target).attr('data-label');
            instalmentAmountLabel.text(fieldLabelName);
          });
        }
      }
    
      initCheckAllBanksCheckboxs () {
        let banksList = $('div[data-fh-name="show_banks"]');
        let field = banksList.find('#check-all');
    
        if (field.length) {
          field.click(function(){
            $('div[data-fh-name="show_banks"] input:checkbox').not(this).prop('checked', this.checked);
          });
        }
      }
    
      initOpenSendMessageForm () {
        let openSendMessageFormBtn = $('.send-message-button');
    
        if(!openSendMessageFormBtn.length) {
          return
        }
    
        openSendMessageFormBtn.on('click', (e) => {
          e.preventDefault();
          let sendMessageForm = $('.send-message-quick-form');
    
          openSendMessageFormBtn.addClass('is-hidden');
          sendMessageForm.addClass('is-open');
        });
      }
    
      initshowPhone () {
        $(document.body).on('click', function (e) {
          if (e.target.nodeName === 'SPAN' && $(e.target).attr('class') === 'block-advisers__item-phone') {
            $.ajax({
              url: $(e.target).parents('.show-contact-info').attr('data-url'),
              type: 'GET',
              dataType: 'json'
            }).done((response) => {
              $(e.target).find('.phone').html('<a href="tel:' + response.mobile_phone +'">' + response.mobile_phone + '</a>');
              $(e.target).find('.phone').addClass('is-open');
            }).fail((response) => {
              console.log(response);
            });
          }
        });
    
        $(document.body).on('click', function (e) {
          if (e.target.nodeName === 'SPAN' && $(e.target).attr('class') === 'block-advisers__item-mail') {
            $.ajax({
              url: $(e.target).parents('.show-contact-info').attr('data-url'),
              type: 'GET',
              dataType: 'json'
            }).done((response) => {
              $(e.target).find('.email').html('<a href="mailto:' + response.email +'">' + response.email + '</a>');
              $(e.target).find('.email').addClass('is-open');
            }).fail((response) => {
              console.log(response);
            });
          }
        });
      }
    
      initAdvisorOpinionHelpful () {
        $('.advisor-opinion-helpful-thumb-up a, .advisor-opinion-helpful-thumb-down a').on('click', (e) => {
          e.preventDefault();
          let recaptchaSiteKey = $('#advisor-opinions').attr('data-recaptcha-site-key');
    
          grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function(recaptchaResponse) {
              let wrapper = $(e.target).parents('.advisor-opinion-helpful');
              let actionURL = $('#advisor-opinions').attr('data-thumb-url');
              let id = parseInt($(e.target).attr('data-id'), 10);
              let thumb = $(e.target).attr('data-thumb');
    
              if (thumb !== 'up' && thumb !== 'down') {
                return;
              }
    
              $.ajax({
                url: actionURL,
                type: 'POST',
                dataType: 'json',
                data: {
                  id: id,
                  thumb: thumb,
                  'g-recaptcha-response': recaptchaResponse
                },
                beforeSend: () => {
                  wrapper.find('.advisor-opinion-helpful-thumb-up').addClass('is-loading');
                  wrapper.find('.advisor-opinion-helpful-thumb-down').addClass('is-loading');
                }
              }).done((response) => {
                wrapper.find('.advisor-opinion-helpful-thumb-up-count').text(response.thumb_up_count);
                wrapper.find('.advisor-opinion-helpful-thumb-down-count').text(response.thumb_down_count);
                wrapper.find('.advisor-opinion-helpful-thumb-up').removeClass('is-loading');
                wrapper.find('.advisor-opinion-helpful-thumb-down').removeClass('is-loading');
              }).fail(() => {
                wrapper.find('.advisor-opinion-helpful-thumb-up').removeClass('is-loading');
                wrapper.find('.advisor-opinion-helpful-thumb-down').removeClass('is-loading');
              });
            });
          });
        });
      }
    
      initChangeFontSize () {
        let htmlTag = $('html');
        let accessibilityBlock = $('.accessibility-block');
        let accessibilityBtnRegular = accessibilityBlock.find('button.normal-font');
        let accessibilityBtnLarge = accessibilityBlock.find('button.large-font');
        let accessibilityBtnHuge = accessibilityBlock.find('button.huge-font');
    
        accessibilityBtnRegular.click(function(e) {
          htmlTag.removeClass('large-font');
          htmlTag.removeClass('huge-font');
          window.localStorage.setItem('finhub-font-size', 'normal-font');
        });
    
        accessibilityBtnLarge.click(function(e) {
          htmlTag.addClass('large-font');
          htmlTag.removeClass('huge-font');
          htmlTag.removeClass('normal-font');
          window.localStorage.setItem('finhub-font-size', 'large-font');
        });
    
        accessibilityBtnHuge.click(function(e) {
          htmlTag.removeClass('large-font');
          htmlTag.addClass('huge-font');
          htmlTag.removeClass('normal-font');
          window.localStorage.setItem('finhub-font-size', 'huge-font');
        });
      }
    
      initFocusKeyboard () {
        let htmlTag = $('html');
        let selectWrapper = $('.select-wrapper');
        let selectLang = selectWrapper.find('.select-language');
    
        $('body').mousedown( function() {
            htmlTag.addClass('mouse');
            htmlTag.removeClass('keyboard');
            htmlTag.attr('data-whatintent', 'mouse');
    
            if (selectWrapper.length) {
                selectLang.attr("size", '');
            }
        });
    
        $('body').keydown( function(e) {
          if (e.keyCode === 9) {
            htmlTag.addClass('keyboard');
            htmlTag.removeClass('mouse');
            htmlTag.attr('data-whatintent', 'keyboard');
    
            if (selectWrapper.length) {
              let selectOptions = selectLang.find('option');
    
              selectLang.focus(function(e) {
                selectLang.attr("size", selectOptions.length);
              });
    
              selectLang.blur(function(e) {
                selectLang.attr("size", '');
              });
            }
          }
        });
      }
    
      initInfoAfterClickTargetBlank () {
        let extendLinks = $('a[target="_blank"]');
    
        for (let i = 0; i < extendLinks.length; i++) {
          let extendLink = extendLinks.eq(i);
          let extendLinkUrl = extendLink.attr('href');
          let extendExtension = extendLinkUrl.split('.').pop();
    
          if (extendExtension === 'pdf') {
            extendLink.on('click', function(e) {
              let response = confirm("Link prowadzi do pliku PDF i zostanie otwarty w nowym oknie.");
    
              if (!response) {
                e.preventDefault();
              }
            });
          } else {
            extendLink.on('click', function(e) {
              let response = confirm("Link zostanie otwarty w nowym oknie.");
    
              if (!response) {
                e.preventDefault();
              }
            });
          }
        }
      }
    
      initOnchangeSelect () {
        let sortSelect = $('#sort-select');
    
        sortSelect.on('change', function() {
          this.form.submit()
        });
      }
    
      showSearchAdvisorForm () {
        let openSearchAdvisorFormBtn = $('#show-form-button');
    
        if(!openSearchAdvisorFormBtn.length) {
          return
        }
    
        let advisorCityInput = $('#search-advisor-city');
        let advisorCityResults = $('#search-advisor-city-results');
        let debouncedDownload = this.debounce((phrase) => this.downloadCities(phrase), 750);
    
        advisorCityInput.on('input', (e) => {
          let searchPhrase = advisorCityInput.val();
          advisorCityResults.removeClass('is-hidden').addClass('is-loading');
          debouncedDownload(searchPhrase);
        });
    
        openSearchAdvisorFormBtn.on('click', (e) => {
          e.preventDefault();
          let SearchAdvisorForm = $('#show-form-form');
          SearchAdvisorForm.removeClass('hidden');
        });
    
        $(document.body).on('click', e => {
          $('#search-advisor-city-results').addClass('is-hidden');
          $('#search-advisor-city-results-content').html('');
        });
    
        $('#search-advisor-city-results').on('click', e => {
          e.stopPropagation();
    
          if (e.target.tagName === 'LI' && $(e.target).hasClass('search-advisor-city-results-item')) {
            $('#search-advisor-city').val($(e.target).text());
            $('#search-advisor-city-results').addClass('is-hidden');
            $('#search-advisor-city-results-content').html('');
            return;
          }
        });
      }
    
      downloadCities (searchPhrase) {
        if (searchPhrase.length < 3) {
          return;
        }
    
        let id = +new Date();
        this.lastAdvisorCityRequestID = id;
    
        $.ajax({
          url: '/advisers/search-places?term=' + encodeURIComponent(searchPhrase),
          type: 'POST'
        }).done((result) => {
          if (id === this.lastAdvisorCityRequestID) {
            $('#search-advisor-city-results').removeClass('is-loading');
    
            if (result.date.length) {
              $('#search-advisor-city-results-content').html('<ol class="search-advisor-city-results-items"><li class="search-advisor-city-results-item">' + result.date.join('</li><li class="search-advisor-city-results-item">') + '</li></ol>');
            } else {
              $('#search-advisor-city-results-content').html('<ol class="search-advisor-city-no-results"><li>' +  this.i18n.noresults + '&hellip;</li></ol>')
            }
          }
        }).fail(() => {
          $('#search-advisor-city-results').removeClass('is-loading');
          $('#search-advisor-city-results').addClass('is-hidden');
        });
      }
    
      debounce(func, timeout = 500) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
      }
    }
    
    /**
     * Advisors Single Map script
     */
    class FinHub_AdvisorsSingleMap {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.advisorPage = $('.advisor-single');
        this.advisorMapSection = this.advisorPage.find('.advisor-map');
        this.map = this.advisorMapSection.find('.map');
        this.mapOverlayBtn = this.advisorMapSection.find('.map-overlay-button');
        this.mapWrapper = this.advisorMapSection.find('#advisor-map-wrapper');
        this.lat = parseFloat(this.mapWrapper.attr('data-lat'));
        this.lng = parseFloat(this.mapWrapper.attr('data-lng'));
    
        if (this.mapOverlayBtn.length) {
          this.initEvents();
          this.initGlobalCallback();
        }
      }
    
      initEvents() {
        this.mapOverlayBtn.on('click', e => {
          e.preventDefault();
          let script = document.createElement('script');
          script.setAttribute('src', this.mapOverlayBtn.attr('data-maps-src'));
          $(script).appendTo(document.body);
        });
      }
    
      initGlobalCallback () {
        window.initAdviserMap = () => {
          this.map.addClass('is-active');
    
          const markerPosition = { 
            lat: this.lat, 
            lng: this.lng
          };
    
          let map = new google.maps.Map(document.getElementById('advisor-map-wrapper'), {
            zoom: 10,
            center: markerPosition,
          });
    
          new google.maps.Marker({
            position: markerPosition,
            map: map,
          });
        };
      }
    }
    /**
     * Advisors Archive Page Map script
     */
    class FinHub_AdvisorsArchiveMap {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.advisorArchive = $('.advisor-list-with-map');
            this.advisorMapSection = this.advisorArchive.find('.advisor-map');
            this.map = this.advisorMapSection.find('.map');
            this.mapInstance = false;
            this.markersList = [];
            this.mapOverlayBtn = this.advisorMapSection.find('.map-overlay-button');
            this.mapWrapper = this.advisorMapSection.find('.advisor-map-wrapper');
    
            if (this.mapOverlayBtn.length) {
                this.initEvents();
                this.initGlobalCallback();
            }
        }
    
        initEvents() {
            this.mapOverlayBtn.on('click', e => {
                e.preventDefault();
    
                if (!this.map.hasClass('is-active')) {
                    this.map.addClass('is-active');
                }
    
                if ($('#finhub-gmaps-script').length) {
                    window.updateAdvisorsMap();
                    return;
                }
    
                let script = document.createElement('script');
                script.setAttribute('src', this.mapOverlayBtn.attr('data-maps-src'));
                script.setAttribute('id', 'finhub-gmaps-script');
                $(script).appendTo(document.body);
            });
        }
    
        initGlobalCallback() {
            window.updateAdvisorsMap = () => {
                if (!this.map.hasClass('is-active')) {
                    return;
                }
    
                if (!this.mapInstance) {
                    this.mapInstance = new google.maps.Map(document.querySelector('.advisor-map-wrapper'), {
                        zoom: 10
                    });
    
                    this.markersList = [];
                } else {
                    for (let i = 0; i < this.markersList.length; i++) {
                        this.markersList[i].setMap(null);
                    }
    
                    this.markersList = [];
                }
    
                let finhubAdvisersList = [];
                let adviserItems = $('.block-advisers__item');
    
                for (let i = 0; i < adviserItems.length; i++) {
                    let item = adviserItems.eq(i);
    
                    if (item.attr('data-latitude') && item.attr('data-longitude')) {
                        finhubAdvisersList.push({
                            id: parseInt(item.attr('data-adviser-id'), 10),
                            name: item.attr('data-name'),
                            surname: item.attr('data-surname'),
                            latitude: parseFloat(item.attr('data-latitude')),
                            longitude: parseFloat(item.attr('data-longitude'))
                        });
                    }
                }
    
                for (let i = 0; i < finhubAdvisersList.length; i++) {
                    let advisorData = finhubAdvisersList[i];
                    let markerItem = new google.maps.Marker({
                        position: {
                            lat: advisorData.latitude,
                            lng: advisorData.longitude
                        },
                        map: this.mapInstance,
                        fhAdviserID: advisorData.id
                    });
    
                    markerItem.addListener('click', function () {
                        let adviserID = parseInt(this['fhAdviserID'], 10);
                        $('.block-advisers__item').removeClass('is-highlighted');
                        $('.block-advisers__item[data-adviser-id="' + adviserID + '"]').addClass('is-highlighted');
                        $('.block-advisers__item[data-adviser-id="' + adviserID + '"]')[0].scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        });
                    });
    
                    this.markersList.push(markerItem);
                }
    
                var bounds = new google.maps.LatLngBounds();
    
                for (var i = 0; i < this.markersList.length; i++) {
                    bounds.extend(this.markersList[i].getPosition());
                }
    
                if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                    var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
                    var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
                    bounds.extend(extendPoint1);
                    bounds.extend(extendPoint2);
                }
    
                this.mapInstance.fitBounds(bounds);
                google.maps.event.trigger(this.mapInstance, 'resize');
            };
        }
    }
    
    /**
     * Form steps script
     */
     class FinHub_FormLoginOrRegister {
        constructor () {
            this.stepAuth = $('.form-with-login-or-register .step-auth[data-url-email-exists]');
    
            if (this.stepAuth.length) {
                this.initEvents();
            }
        }
    
        initEvents () {
            this.lastStep = $('.form-with-login-or-register .form-step-with-auth');
            
            this.stepAuth.find('.btn-login').on('click', e => {
                e.preventDefault();
                this.login();
            });
    
            this.stepAuth.find('.btn-register').on('click', e => {
                e.preventDefault();
                this.register();
            });
    
            this.stepAuth.find('.register-form input[name="password"]').on('input', () => {
                if (this.stepAuth.find('.register-form input[name="password"]').val().length < 8) {
                    this.stepAuth.find('.register-form .validation-error-too-short').removeClass('is-hidden');
                } else {
                    this.stepAuth.find('.register-form .validation-error-too-short').addClass('is-hidden');
                }
            });
    
            this.stepAuth.find('.register-form input[name="password_confirmation"]').on('input', () => {
                let password = this.stepAuth.find('.register-form input[name="password"]').val();
                let passwordConfirmation = this.stepAuth.find('.register-form input[name="password_confirmation"]').val();
    
                if (password !== passwordConfirmation) {
                    this.stepAuth.find('.register-form .validation-error-not-match').removeClass('is-hidden');
                } else {
                    this.stepAuth.find('.register-form .validation-error-not-match').addClass('is-hidden');
                }
            });
        }
    
        showForm () {
            this.lastStep = $('.form-with-login-or-register .form-step-with-auth');
    
            let loader = this.lastStep.find('.step-auth-loading');
            let loginForm = this.lastStep.find('.login-form');
            let registerForm = this.lastStep.find('.register-form');
            let emailToCheck = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();
    
            if (loader.attr('data-checked-email') !== emailToCheck) {
                loader.removeClass('is-hidden');
                loginForm.addClass('is-hidden');
                registerForm.addClass('is-hidden');
                this.checkMail(emailToCheck);
            }
        }
    
        checkMail (emailToCheck) {
            let loader = this.lastStep.find('.step-auth-loading');
            let loginForm = this.lastStep.find('.login-form');
            let registerForm = this.lastStep.find('.register-form');
            let token = $('.form-with-login-or-register input[name="_token"]').val();
            this.lastStep.find('.step-auth-loading').attr('data-checked-email', emailToCheck);
    
            $.post(
                this.lastStep.find('.step-auth').attr('data-url-email-exists'),
                {
                    email: emailToCheck,
                    token: token
                },
                (result) => {
                    loader.addClass('is-hidden');
    
                    if (result.exists) {
                        loginForm.removeClass('is-hidden');
                        loginForm.find('.login-form-username').text(emailToCheck);
                        registerForm.addClass('is-hidden');
                    } else {
                        loginForm.addClass('is-hidden');
                        registerForm.find('.register-form-username').text(emailToCheck);
                        registerForm.removeClass('is-hidden');
                    }
                }
            );
        }
    
        login () {
            let email = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();
            let password = this.lastStep.find('.login-form input[name="password"]').val();
            let loader = this.lastStep.find('.step-auth-loading');
            loader.removeClass('is-hidden');
    
            $.post(
                this.stepAuth.find('.login-form ').attr('data-url'),
                {
                    email: email,
                    password: password
                }
            ).done((result) => {
                loader.addClass('is-hidden');
                
                if (result.id) {
                    this.submitMainForm();
                } else {
                    loader.addClass('is-hidden');
                    $('.login-form .validation-error').removeClass('is-hidden');
    
                    this.lastStep.find('.login-form input[name="password"]').one('input', () => {
                        $('.login-form .validation-error').addClass('is-hidden');
                    });
    
                    console.log(result);
                }
            }).fail((result) => {
                loader.addClass('is-hidden');
                $('.login-form .validation-error').removeClass('is-hidden');
    
                this.lastStep.find('.login-form input[name="password"]').one('input', () => {
                    $('.login-form .validation-error').addClass('is-hidden');
                });
                
                console.log(result);
            });
        }
    
        register () {
            let email = $('.form-with-login-or-register .form-step-contact-data input[name="customer_email"]').val();
            let password = this.lastStep.find('.register-form input[name="password"]').val();
            let password_confirmation = this.lastStep.find('.register-form input[name="password_confirmation"]').val();
            let loader = this.lastStep.find('.step-auth-loading');
            let name = $('.form-with-login-or-register .form-step-contact-data input[name="customer_name"]').val();
            let surname = $('.form-with-login-or-register .form-step-contact-data input[name="customer_surname"]').val();
            let phone = $('.form-with-login-or-register .form-step-contact-data input[name="customer_phone"]').val();
            let city = $('.form-with-login-or-register .form-step-contact-data input[name="customer_city"]').val();
            let post_code = $('.form-with-login-or-register .form-step-contact-data input[name="customer_post_code"]').val();
            let accepted_regulations = $('.form-with-login-or-register .form-step-contact-data input[name="customer_accepted_terms_and_policy_privacy"]').val();
            let accepted_policy_privacy = $('.form-with-login-or-register .form-step-contact-data input[name="customer_contact_adviser_agreement"]').val();
            let contact_agreement = $('.form-with-login-or-register .form-step-contact-data input[name="customer_contact_finhub_agreement"]').val();
            let registerForm = this.stepAuth.find('.register-form');
    
            if (password.length < 8) {
                registerForm.find('.validation-error-too-short').removeClass('is-hidden');
                return;
            }
    
            if (password !== password_confirmation) {
                registerForm.find('.validation-error-not-match').removeClass('is-hidden');
                return;
            }
    
            loader.removeClass('is-hidden');
    
            $.post(
                registerForm.attr('data-url'),
                {
                    email: email,
                    password: password,
                    password_confirmation: password_confirmation,
                    name: name, 
                    surname: surname, 
                    phone: phone,
                    accepted_terms_and_policy_privacy: accepted_regulations, 
                    contact_adviser_agreement: accepted_policy_privacy, 
                    contact_finhub_agreement: contact_agreement,
                    city: city,
                    post_code: post_code
                }
            ).done((result) => {
                loader.addClass('is-hidden');
                
                if (result.data.customer_id) {
                    if ($('.form-with-login-or-register input[name="customer_id"]').length) {
                        $('.form-with-login-or-register input[name="customer_id"]').val(result.data.customer_id);
                    } else {
                        let customerIdField = $('<input type="hidden" name="customer_id" />');
                        customerIdField.val(result.data.customer_id);
                        customerIdField.appendTo($('.form-with-login-or-register'));
                    }
    
                    setTimeout(() => {
                        this.submitMainForm();
                    }, 0);
                } else {
                    loader.addClass('is-hidden');
                    $('.register-form .validation-error-common-error').removeClass('is-hidden');
                    console.log(result);
                }
            }).fail((result) => {
                loader.addClass('is-hidden');
                $('.register-form .validation-error-common-error').removeClass('is-hidden');
                console.log(result);
            });
        }
    
        submitMainForm () {
            let form = $('.form-with-login-or-register');
            form.find('.login-form').remove();
            form.find('.register-form').remove();
    
            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: form.serialize()
            }).done ((data) => {
                console.log(data);
                $('.form-step-summary').removeClass('is-hidden');
                $('.wrapper[data-current-step]').addClass('is-sent-successfully');
    
                if (data.adviser) {
                    $('.form-step-summary').find('.advisor-image img').attr('src', data.adviser.image_url);
                    $('.form-step-summary').find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                    $('.form-step-summary').removeClass('is-hidden');
                    $('.wrapper[data-current-step]').addClass('is-sent-successfully');
                }
            }).fail((result) => {
                console.log('FAIL', result);
            });
        }
    }
    
    /**
     * Form advisor choose script
     */
    class FinHub_FormStepsAdvisorChoose {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
            this.stepFormAdviserWrapper = $('.js-form-adviser');
            this.authStepForm = null;
    
            if (!this.stepFormAdviserWrapper.length) {
                return;
            }
    
            this.initFormAdviser();
            this.initSearchAdvisor();
    
            if (this.hasAuthStep()) {
                this.authStepForm = new FinHub_FormLoginOrRegister();
            }
        }
    
        initFormAdviser() {
            this.prevStepAdviser = this.stepFormAdviserWrapper.find('.prev-step');
            this.adviserProgressBar = this.stepFormAdviserWrapper.find('.progress-bar');
            this.adviserProgressBarItem = this.adviserProgressBar.find('li');
            this.firstStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="0"]');
            this.secondStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="1"]');
            this.lastStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="2"]');
            this.summaryStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="3"]');
            this.firstNextStepAdviserBtn = this.firstStepForm.find('.next-step');
            this.secondNextStepAdviserBtn = this.secondStepForm.find('.next-step');
            this.submitAdviser = this.stepFormAdviserWrapper.find('.btn-submit');
    
            this.prevStepAdviser.on('click', e => {
                e.preventDefault();
                this.currentStep = parseInt(this.stepFormAdviserWrapper.attr('data-current-step'), 10);
                let currentStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="' + this.currentStep + '"]');
                let prevStepForm = this.stepFormAdviserWrapper.find('.form-step[data-step="' + (this.currentStep - 1) + '"]');
    
                this.adviserProgressBarItem.eq(this.currentStep).removeClass('active');
                this.adviserProgressBarItem.eq(this.currentStep - 1).addClass('active');
                prevStepForm.addClass('active');
                currentStepForm.removeClass('active');
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#progress-bar").offset().top
                }, 100);
    
                this.currentStep--;
                this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
            });
    
            let formHelperStep1 = new FinHub_FormHelper(this.firstStepForm);
            let formHelperStep2 = new FinHub_FormHelper(this.secondStepForm);
            let formHelperLastStepForm = new FinHub_FormHelper(this.lastStepForm)
    
            formHelperStep1.formDependencies([
                {
                    useCollection: true,
                    field: 'transaction-type-id',
                    dependsOn: 'input[name="transaction_type_id"]',
                    elementsToShow: (value) => this.firstStepForm.find('[data-transaction-type-id="' + value + '"]')
                },
                {
                    field: 'is_need_finishing',
                    dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
                    showOn: () => {
                        let selectedTransactionType = this.firstStepForm.find('input[name="transaction_type_id"]:checked');
    
                        if (!selectedTransactionType.length) {
                            return false;
                        }
    
                        let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
                        let selectedSubject = this.firstStepForm.find('input[name="transaction_subject_id"]:checked');
    
                        if (!selectedSubject.length) {
                            return false;
                        }
    
                        let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');
    
                        return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
                    }
                },
                {
                    field: 'need_finishing_amount',
                    dependsOn: 'input[name="is_need_finishing"]',
                    showOn: (value) => value == 1
                }
            ]);
    
            this.firstNextStepAdviserBtn.on('click', e => {
                e.preventDefault();
                let result = formHelperStep1.formValidate();
                this.currentStep = 1;
    
                if (result) {
                    this.firstStepForm.addClass('is-loading');
    
                    setTimeout(() => {
                        this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
                        this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                        this.firstStepForm.removeClass('active');
                        this.firstStepForm.removeClass('is-loading');
                        this.secondStepForm.addClass('active');
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#progress-bar").offset().top
                        }, 100);
                    }, 1000);
                }
            });
    
            this.secondNextStepAdviserBtn.on('click', e => {
                e.preventDefault();
                let result = formHelperStep2.formValidate();
                this.currentStep = 2;
    
                if (result) {
                    this.secondStepForm.addClass('is-loading');
    
                    setTimeout(() => {
                        this.stepFormAdviserWrapper.attr('data-current-step', this.currentStep);
                        this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                        this.secondStepForm.removeClass('active');
                        this.secondStepForm.removeClass('is-loading');
                        this.lastStepForm.addClass('active');
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $("#progress-bar").offset().top
                        }, 100);
                    }, 1000);
                }
            });
    
            this.submitAdviser.on('click', e => {
                e.preventDefault();
                let result = formHelperLastStepForm.formValidate();
                this.currentStep = 3;
    
                if (result) {
                    this.lastStepForm.addClass('is-loading');
    
                    setTimeout(() => {
                        this.lastStepForm.removeClass('is-loading');
                        this.adviserProgressBarItem.eq(this.currentStep).addClass('active');
                        this.lastStepForm.removeClass('active');
                        this.summaryStepForm.addClass('active');
    
                        if (this.authStepForm) {
                            this.authStepForm.showForm();
                        } else {
                            let form = this.stepFormAdviserWrapper.find('form');
    
                            $.ajax({
                                type: 'POST',
                                url: form.attr('action'),
                                data: form.serialize(),
                                success: (data) => {
                                    console.log(data);
                                    this.summaryStepForm.find('.advisor-image img').attr('src', data.adviser.image_url);
                                    this.summaryStepForm.find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                                    $('.form-step-summary').removeClass('is-hidden');
                                    $('.wrapper[data-current-step]').addClass('is-sent-successfully');
                                }
                            });
                        }
                    }, 1000);
                }
            });
        }
    
        initSearchAdvisor() {
            let goToStep3AdvisorFormBtn = $('#go_to_step_3');
    
            if (!goToStep3AdvisorFormBtn.length) {
                return;
            }
    
            goToStep3AdvisorFormBtn.click(e => {
                e.preventDefault();
                let postCode = $('input[name="customer_post_code"]').val();
                let cityName = $('input[name="customer_city"]').val();
                $('.advisors-list').addClass('is-loading');
                $('.advisors-list').empty();
                $('input[name="adviser_id"]').val('');
                $('.btn-submit').attr('disabled', true);
    
                $.post(
                    $('.form-adviser-search').attr('data-advisor-search'),
                    {
                        address: postCode + ' ' + cityName
                    },
                    (data) => {
                        if ($('.map.is-active').length) {
                            $('.advisor-map-wrapper').empty();
                            $('.advisor-map-wrapper').removeAttr('style');
                            $('.map').removeClass('is-active');
                        }
    
                        $('.advisors-list').removeClass('is-loading');
                        window.finhubAdvisersList = [];
    
                        for (let i = 0; i < data.advisers.length; i++) {
                            this.renderAdvisor(data.advisers[i]);
    
                            if (data.advisers[i].latitude && data.advisers[i].longitude) {
                                console.log(data);
                                window.finhubAdvisersList.push({
                                    id: data.advisers[i].id,
                                    name: data.advisers[i].name,
                                    surname: data.advisers[i].surname,
                                    latitude: parseFloat(data.advisers[i].latitude),
                                    longitude: parseFloat(data.advisers[i].longitude)
                                });
                            }
                        }
                    }
                );
            });
    
            $('.advisors-list').on('click', e => {
                if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#select-advisor') {
                    $('.block-advisers__item a[href="#select-advisor"]').removeClass('is-selected');
                    $(e.target).addClass('is-selected');
                    $('input[name="adviser_id"]').val($(e.target).attr('data-id'));
                    $('.btn-submit').attr('disabled', false);
                }
            });
        }
    
        renderAdvisor(advisorData) {
            let template = `
        <div class="block-advisers__item" data-adviser-id="">
          <div class="block-advisers__item-image">
            <img src="" alt="" loading="lazy">
          </div>
          <div class="block-advisers__item-text" data-featured="{{ $item->promoted == 1 ? 'Tak' : 'Nie' }}">
            <div class="row">
              <div class="block-advisers__item-info">
                <h1 class="block-advisers__item-name"></h1>
                <span class="block-advisers__item-rating">
                    <div class="rating-stars" data-rating="">
                        <svg class="star">
                            <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                        </svg>
                        <svg class="star">
                            <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                        </svg>
                        <svg class="star">
                            <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                        </svg>
                        <svg class="star">
                            <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                        </svg>
                        <svg class="star">
                            <use xlink:href="front/images/icons/svg-map.svg#star"></use>
                        </svg>
                    </div>
                    <span class="block-advisers__item-rating_sum"></span>
                </span>
                <p class="block-advisers__item-desc"></p>
              </div>
              <div class="block-advisers__item-buttons">
                <a href="#select-advisor" data-id="" class="btn btn-primary btn-small">
                  ` + this.i18n.choose + `
                </a>
              </div>
            </div>
            <div class="row">
              <span class="block-advisers__item-city">
                <svg class="icon">
                  <use xlink:href="./front/images/icons/svg-map.svg#map-marker"></use>
                </svg>
                <span class="block-advisers__item-city-name"></span>
                <span class="block-advisers__item-languages"></span>
              </span>
            </div>
          </div>
        </div>`;
            let templateElement = $(template);
            templateElement.attr('data-adviser-id', advisorData.id);
            templateElement.find('.block-advisers__item-image img').attr('src', advisorData.image_url);
            templateElement.find('.block-advisers__item-name').text(advisorData.name + ' ' + advisorData.surname);
            templateElement.find('.rating-stars').attr('data-rating', Math.round(advisorData.opinions_avg_note));
            templateElement.find('.block-advisers__item-rating_sum').text(advisorData.opinions_count + " opinie");
            templateElement.find('.block-advisers__item-desc').text(advisorData.short_description);
            templateElement.find('.block-advisers__item-buttons .btn-primary').attr('data-id', advisorData.id);
            templateElement.find('.block-advisers__item-city-name').text(advisorData.city);
            for (const value of advisorData.markets) {
                templateElement.find('.block-advisers__item-languages').append(`<img src="${window.location.origin + `/front/images/flags/${value.code}.png`}" alt="${value.name}">`);
            }
            templateElement.find('.block-advisers__item-text').attr('data-featured', advisorData.promoted ? 'Tak' : 'Nie');
            templateElement.appendTo($('.advisors-list'))
        }
    
        hasAuthStep() {
            let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');
    
            if (authStep.length) {
                return true;
            }
    
            return false;
        }
    }
    
    /**
     * Form steps compare offer script
     */
     class FinHub_FormStepsCompareOffer {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.stepFormCompareWrapper = $('.js-form-compare');
        this.authStepForm = null;
    
        if (!this.stepFormCompareWrapper.length) {
          return;
        }
    
        this.mainForm = this.stepFormCompareWrapper.find('form');
        this.initFormCompare();
    
        if (this.hasAuthStep()) {
          this.authStepForm = new FinHub_FormLoginOrRegister();
        }
      }
    
      initFormCompare () {
        this.listData = {
          incomes: [],
          liabilities: []
        };
        this.i18n = JSON.parse(JSON.stringify(window.finHubLangs));
        this.prevStepCompare = this.stepFormCompareWrapper.find('.prev-step');
        this.compareProgressBar = this.stepFormCompareWrapper.find('.progress-bar');
        this.compareProgressBarItem = this.compareProgressBar.find('li');
        this.firstStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="0"]');
        this.secondStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="1"]');
        this.thirdStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="2"]');
        this.fourthStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="3"]');
        this.fifthStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="4"]');
        this.lastStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="5"]');
        this.summaryStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="6"]');
        this.firstNextStepCompareBtn = this.firstStepForm.find('.next-step');
        this.secondNextStepCompareBtn = this.secondStepForm.find('.next-step');
        this.thirdNextStepCompareBtn = this.thirdStepForm.find('.next-step');
        this.fourthNextStepCompareBtn = this.fourthStepForm.find('.next-step');
        this.fifthNextStepCompareBtn = this.fifthStepForm.find('.next-step');
        this.submitCompare = this.stepFormCompareWrapper.find('.btn-submit');
        this.currentStep = parseInt(this.stepFormCompareWrapper.attr('data-current-step'), 10);
    
        this.prevStepCompare.on('click', e => {
          e.preventDefault();
          this.currentStep = parseInt(this.stepFormCompareWrapper.attr('data-current-step'), 10);
          let currentStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="' + this.currentStep +'"]');
          let prevStepForm = this.stepFormCompareWrapper.find('.form-step[data-step="' + (this.currentStep - 1) +'"]');
    
          this.compareProgressBarItem.eq(this.currentStep).removeClass('active');
          this.compareProgressBarItem.eq(this.currentStep - 1).addClass('active');
          prevStepForm.addClass('active');
          currentStepForm.removeClass('active');
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#progress-bar").offset().top
          }, 100);
    
          this.currentStep--;
          this.stepFormCompareWrapper.attr('data-current-step', this.currentStep);
        });
    
        this.initEventListeners();
        this.initListEventListeners();
    
        let formHelperStep1 = new FinHub_FormHelper(this.firstStepForm);
        let formHelperStep2 = new FinHub_FormHelper(this.secondStepForm);
        let formHelperStep3 = new FinHub_FormHelper(this.thirdStepForm);
        let formHelperStep4 = new FinHub_FormHelper(this.fourthStepForm);
        let formHelperStep5 = new FinHub_FormHelper(this.fifthStepForm);
        let formHelperLastStepForm = new FinHub_FormHelper(this.lastStepForm)
    
        formHelperStep1.formDependencies([
          {
            useCollection: true,
            field: 'transaction-type-id',
            dependsOn: 'input[name="transaction_type_id"]',
            elementsToShow: (value) => this.firstStepForm.find('[data-transaction-type-id="' + value + '"]')
          },
          {
            field: 'is_need_finishing',
            dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
            showOn: () => {
              let selectedTransactionType = this.firstStepForm.find('input[name="transaction_type_id"]:checked');
    
              if (!selectedTransactionType.length) {
                return false;
              }
    
              let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
              let selectedSubject = this.firstStepForm.find('input[name="transaction_subject_id"]:checked');
    
              if (!selectedSubject.length) {
                return false;
              }
    
              let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');
    
              return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
            }
          },
          {
            field: 'need_finishing_amount',
            dependsOn: 'input[name="is_need_finishing"]',
            showOn: (value) => value == 1
          }
        ]);
    
        formHelperLastStepForm.formDependencies([
          {
            field: 'show_banks',
            dependsOn: 'input[name="selected_banks"]',
            showOn: (value) => value == 1
          }
        ]);
    
        this.firstNextStepCompareBtn.on('click', e => {
          e.preventDefault();
          this.goToNextStep(this.firstStepForm, this.secondStepForm, formHelperStep1, 1);
        });
    
        this.secondNextStepCompareBtn.on('click', e => {
          e.preventDefault();
          this.goToNextStep(this.secondStepForm, this.thirdStepForm, formHelperStep2, 2);
        });
    
        this.thirdNextStepCompareBtn.on('click', e => {
          e.preventDefault();
          this.goToNextStep(this.thirdStepForm, this.fourthStepForm, formHelperStep3, 3);
        });
    
        this.fourthNextStepCompareBtn.on('click', e => {
          e.preventDefault();
          this.goToNextStep(this.fourthStepForm, this.fifthStepForm, formHelperStep4, 4);
        });
    
        this.fifthNextStepCompareBtn.on('click', e => {
          e.preventDefault();
          this.goToNextStep(this.fifthStepForm, this.lastStepForm, formHelperStep5, 5);
        });
    
        this.submitCompare.on('click', e => {
          e.preventDefault();
          let result = formHelperLastStepForm.formValidate();
          this.currentStep = 6;
    
    			if (result) {
            this.lastStepForm.addClass('is-loading');
    
            setTimeout(() => {
              this.lastStepForm.removeClass('is-loading');
              this.compareProgressBarItem.eq(this.currentStep).addClass('active');
              this.lastStepForm.removeClass('active');
              this.summaryStepForm.addClass('active');
    
              if (this.authStepForm) {
                this.authStepForm.showForm();
              } else {
                let form = this.stepFormCompareWrapper.find('form');
    
                $.ajax({
                  type: 'POST',
                  url: form.attr('action'),
                  data: form.serialize(),
                  success: (data) => {
                    console.log(data);
                    $('.form-step-summary').removeClass('is-hidden');
                    $('.wrapper[data-current-step]').addClass('is-sent-successfully');
                  }
                });
              }
            }, 1000);
    			}
        });
      }
    
      hasAuthStep () {
        let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');
    
        if (authStep.length) {
          return true;
        }
    
        return false;
      }
    
      goToNextStep (currentStepForm, nextStepForm, formHelper, step) {
        currentStepForm.find('.next-step-partial-store-error').addClass('is-valid');
        let result = formHelper.formValidate();
        this.currentStep = step;
    
        if (result) {
          if (step === 3) {
            currentStepForm.find('input[name="incomes[]"]').remove();
    
            setTimeout(() => {
              for (let i = 0; i < this.listData.incomes.length; i++) {
                let newInput = $('<input type="hidden" name="incomes[]" value="">');
                let incomesData = this.prepareJsonData(this.listData.incomes[i]);
                newInput.val(JSON.stringify(incomesData));
                newInput.appendTo(this.thirdStepForm);
              }
    
              setTimeout(() => {
                this.partialStore(currentStepForm, nextStepForm);
              }, 0);
            }, 0);
    
            return;
          }
    
          if (step === 5) {
            currentStepForm.find('input[name="liabilities[]"]').remove();
    
            setTimeout(() => {
              for (let i = 0; i < this.listData.liabilities.length; i++) {
                let newInput = $('<input type="hidden" name="liabilities[]" value="">');
                let liabilitiesData = this.prepareJsonData(this.listData.liabilities[i]);
                newInput.val(JSON.stringify(liabilitiesData));
                newInput.appendTo(this.fifthStepForm);
              }
    
              setTimeout(() => {
                this.partialStore(currentStepForm, nextStepForm);
              }, 0);
            }, 0);
    
            return;
          }
    
          setTimeout(() => {
            this.partialStore(currentStepForm, nextStepForm);
          }, 0);
        }
      }
    
      partialStore (currentStepForm, nextStepForm) {
        currentStepForm.addClass('is-loading');
    
        $.ajax({
          url: this.mainForm.attr('data-store-partial'),
          type: 'POST',
          data: this.prepareSerializedData(currentStepForm)
        }).done((result) => {
          if (result.success) {
            currentStepForm.removeClass('is-loading');
            this.stepFormCompareWrapper.attr('data-current-step', this.currentStep);
            this.compareProgressBarItem.eq(this.currentStep).addClass('active');
            currentStepForm.removeClass('active');
            nextStepForm.addClass('active');
            $([document.documentElement, document.body]).animate({
              scrollTop: $("#progress-bar").offset().top
            }, 100);
          } else {
            this.storePartialError(currentStepForm);
          }
        }).fail(() => {
          this.storePartialError(currentStepForm);
        });
      }
    
      storePartialError (stepForm) {
        stepForm.removeClass('is-loading');
        stepForm.find('.next-step-partial-store-error').removeClass('is-valid');
      }
    
      prepareSerializedData (stepForm) {
        let serializedData = stepForm.find(':input').filter((i, elm) => ($(elm).val() !== '' && $(elm).val() !== null)).serialize();
        serializedData += '&token=' + this.mainForm.find('input[name="token"]').val();
        return serializedData;
      }
    
      initEventListeners () {
        $(document).on('finhub-add-income', this.addIncome.bind(this));
        $(document).on('finhub-add-income-liability', this.addIncomeLiability.bind(this));
        $(document).on('finhub-add-liability', this.addLiability.bind(this));
      }
    
      addIncome (e, data) {
        let dataObject = JSON.parse(data);
        dataObject.liabilities = [];
        this.listData.incomes.push(dataObject);
        $('.incomes-list').empty();
    
        setTimeout(() => {
          this.updateIncomesList();
        }, 0);
      }
    
      addIncomeLiability (e, data, index) {
        console.log(data, index, this.listData.incomes);
        this.listData.incomes[index].liabilities.push(JSON.parse(data));
    
        setTimeout(() => {
          this.updateIncomesList();
        }, 0);
      }
    
      addLiability (e, data) {
        this.listData.liabilities.push(JSON.parse(data));
    
        setTimeout(() => {
          this.updateLiabilitiesList();
        }, 0);
      }
    
      initListEventListeners () {
        $('.liabilities-list').on('click', e => {
          e.preventDefault();
    
          if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-liability') {
            let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
            $('.liabilities-list').find('.liabilities-list-item').eq(indexToRemove).remove();
            this.listData.liabilities.splice(indexToRemove, 1);
          }
        });
    
        $('.incomes-list').on('click', e => {
          e.preventDefault();
    
          if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-income') {
            let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
            this.listData.incomes.splice(indexToRemove, 1);
            this.updateIncomesList();
          }
    
          if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#delete-income-liability') {
            let indexToRemove = parseInt(e.target.getAttribute('data-index'), 10);
            let subindexToRemove = parseInt(e.target.getAttribute('data-subindex'), 10);
            this.listData.incomes[indexToRemove].liabilities.splice(subindexToRemove, 1);
            this.updateIncomesList();
          }
    
          if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#add-liability') {
            let indexToUse = parseInt(e.target.getAttribute('data-index'), 10);
            $('.incomes-liabilities-popup').attr('data-index', indexToUse);
            $('.incomes-liabilities-popup').removeClass('is-hidden');
          }
        });
      }
    
      updateLiabilitiesList () {
        $('.liabilities-list').empty();
        console.log(this.listData.liabilities);
    
        for (let i = 0; i < this.listData.liabilities.length; i++) {
          let data = this.listData.liabilities[i];
          let newItem = $(`<li class="liabilities-list-item">
            <dl>
              <dt> ` + this.i18n.typecommitment + `:</dt>
              <dd class="data-liability_id"></dd>
              <dt>` + this.i18n.repaid + `:</dt>
              <dd class="data-payoff_amount"></dd>
            </dl>
            <a href="#delete-liability" data-index="" class="link link-red">` + this.i18n.delete + `</a>
          </li>`);
    
          let liabilityName = window.fhLiabilities[parseInt(data.liability_id, 10)];
          newItem.find('a[data-index]').attr('data-index', i);
          newItem.find('.data-liability_id').text(liabilityName);
          newItem.find('.data-payoff_amount').text(data.payoff_amount);
          newItem.appendTo($('.liabilities-list'));
        }
      }
    
      updateIncomesList () {
        $('.incomes-list').empty();
        console.log(this.listData.incomes);
    
        for (let i = 0; i < this.listData.incomes.length; i++) {
          let data = this.listData.incomes[i];
          let incomeType = window.fhIncomeTypes[this.listData.incomes[i].income_type_id];
          let newItem = $(`<li class="incomes-list-item">
            <dl>
              <dt>` + this.i18n.sourceofincome + `:</dt>
              <dd class="data-income_id"></dd>
              <dt>` + this.i18n.untilwhen + `:</dt>
              <dd class="data-date_from"></dd>
            </dl>
            <a href="#delete-income" data-index="" class="link link-red">` + this.i18n.delete + `</a>
    
            <ul class="incomes-list-item-liabilities"></ul>
            <a href="#add-liability" data-index="" class="btn btn-primary-outline btn-smallest">` + this.i18n.addcommitment + `</a>
          </li>`);
    
          let incomeName = window.fhIncomes[parseInt(data.income_type_id, 10)];
          newItem.find('a[data-index]').attr('data-index', i);
          newItem.find('.data-income_id').text(incomeName);
          newItem.find('.data-date_from').text(data.date_from);
    
          if (incomeType !== 'BUSINESS_ACTIVITY') {
            newItem.find('.incomes-list-item-liabilities').remove();
            newItem.find('a[href="#add-liability"]').remove();
          } else {
            for (let j = 0; j < this.listData.incomes[i].liabilities.length; j++) {
              let liabilityData = this.listData.incomes[i].liabilities[j];
              let newLiabilityItem = $(`<li class="incomes-list-item-liabilities-item">
                <dl>
                  <dt>` + this.i18n.typecommitment + `:</dt>
                  <dd class="data-liability_id"></dd>
                  <dt>` + this.i18n.repaid + `</dt>
                  <dd class="data-payoff_amount"></dd>
                </dl>
                <a href="#delete-income-liability" data-index="" class="link link-red">` + this.i18n.delete + `</a>
              </li>`);
    
              let liabilityName = window.fhIncomeLiabilities[parseInt(liabilityData.liability_id, 10)];
              newLiabilityItem.find('a[data-index]').attr('data-index', i);
              newLiabilityItem.find('.data-liability_id').text(liabilityName);
              newLiabilityItem.find('.data-payoff_amount').text(liabilityData.payoff_amount);
              newLiabilityItem.appendTo(newItem.find('.incomes-list-item-liabilities'));
            }
          }
    
          newItem.appendTo($('.incomes-list'));
        }
      }
    
      prepareJsonData (input) {
        input = JSON.parse(JSON.stringify(input));
        let keys = Object.keys(input);
    
        for (let i = 0; i < keys.length; i++) {
          if (input[keys] === '' || input[keys] === null) {
            delete input[keys];
          }
        }
    
        return input;
      }
    }
    
    /**
     * Form steps consultation script
     */
     class FinHub_FormStepsConsultation {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.stepFormConsultationWrapper = $('.js-form-consultation');
        this.authStepForm = null;
    
        if (!this.stepFormConsultationWrapper.length) {
          return;
        }
    
        this.initFormConsultation();
    
        if (this.hasAuthStep()) {
          this.authStepForm = new FinHub_FormLoginOrRegister();
        }
      }
    
      initFormConsultation () {
        this.nextStepConsultationBtn = this.stepFormConsultationWrapper.find('.next-step');
        this.submitConsultation = this.stepFormConsultationWrapper.find('.btn-submit');
        this.prevStepConsultation = this.stepFormConsultationWrapper.find('.prev-step');
        this.consultationProgressBar = this.stepFormConsultationWrapper.find('.progress-bar');
        this.consultationProgressBarItem = this.consultationProgressBar.find('li');
        this.consultationFirstStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="1"]');
        this.consultationSecondStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="2"]');
        this.consultationThirdStepForm = this.stepFormConsultationWrapper.find('.form-step[data-step="3"]');
        this.consultationAdvisorId = parseInt(this.stepFormConsultationWrapper.find('form').attr('data-advisor-id'), 10);
    
        this.prevStepConsultation.on('click', e => {
          e.preventDefault();
          this.currentStep = 1;
          this.consultationProgressBarItem.eq(this.currentStep).removeClass('active');
          this.consultationProgressBarItem.eq(this.currentStep - 1).addClass('active');
          this.consultationFirstStepForm.addClass('active');
          this.consultationSecondStepForm.removeClass('active');
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#progress-bar").offset().top
          }, 100);
        });
    
        let formHelperStep1 = new FinHub_FormHelper(this.consultationFirstStepForm);
        let formHelperStep2 = new FinHub_FormHelper(this.consultationSecondStepForm);
    
        formHelperStep2.formDependencies([
          {
            useCollection: true,
            field: 'transaction-type-id',
            dependsOn: 'input[name="transaction_type_id"]',
            elementsToShow: (value) => this.consultationSecondStepForm.find('[data-transaction-type-id="' + value + '"]')
          },
          {
            field: 'is_need_finishing',
            dependsOn: 'input[name="transaction_type_id"], input[name="transaction_subject_id"]',
            showOn: () => {
              let selectedTransactionType = this.consultationSecondStepForm.find('input[name="transaction_type_id"]:checked');
    
              if (!selectedTransactionType.length) {
                return false;
              }
              
              let selectedTransactionTypeMarket = selectedTransactionType.eq(0).attr('data-type');
              let selectedSubject = this.consultationSecondStepForm.find('input[name="transaction_subject_id"]:checked');
    
              if (!selectedSubject.length) {
                return false;
              }
    
              let selectedSubjectNeedFinishing = selectedSubject.eq(0).attr('data-is-need-finishing');
              
              return selectedTransactionTypeMarket === 'PRIMARY_MARKET' && selectedSubjectNeedFinishing == '1';
            }
          },
          {
            field: 'need_finishing_amount',
            dependsOn: 'input[name="is_need_finishing"]',
            showOn: (value) => value == 1
          }
        ]);
    
        this.nextStepConsultationBtn.on('click', e => {
          e.preventDefault();
    			let result = formHelperStep1.formValidate();
          this.currentStep = 1;
    
    			if (result) {
            this.consultationFirstStepForm.addClass('is-loading');
    
            setTimeout(() => {
              this.consultationProgressBarItem.eq(this.currentStep).addClass('active');
              this.consultationFirstStepForm.removeClass('active');
              this.consultationSecondStepForm.addClass('active');
              this.consultationFirstStepForm.removeClass('is-loading');
              $([document.documentElement, document.body]).animate({
                scrollTop: $("#progress-bar").offset().top
              }, 100);
            }, 1000);
    			}
        });
    
        this.submitConsultation.on('click', e => {
          e.preventDefault();
    			let result = formHelperStep2.formValidate();
          this.currentStep = 2;
    
    			if (result) {
            this.consultationSecondStepForm.addClass('is-loading');
    
            setTimeout(() => {
              this.consultationProgressBarItem.eq(this.currentStep).addClass('active');
              this.consultationSecondStepForm.removeClass('active');
              this.consultationThirdStepForm.addClass('active');
              this.consultationSecondStepForm.removeClass('is-loading');
    
              if (this.authStepForm) {
                this.authStepForm.showForm();
              } else {
                let form = this.stepFormConsultationWrapper.find('form');
    
                $.ajax({
                  type: 'POST',
                  url: form.attr('action'),
                  data: form.serialize(),
                  success: (data) => {
                    this.consultationThirdStepForm.find('.advisor-image img').attr('src', data.adviser.image_url);
                    this.consultationThirdStepForm.find('.advisor-name').text(data.adviser.name + ' ' + data.adviser.surname);
                    $('.form-step-summary').removeClass('is-hidden');
                    $('.wrapper[data-current-step]').addClass('is-sent-successfully');
    
                    if (window.fbq != undefined) {
                      window.fbq('track', 'CompleteRegistration', {
                        content_name: (this.consultationAdvisorId).toString() 
                      });
                    }
                  }
                });
              }
            }, 1000);
    			}
        });
      }
    
      hasAuthStep () {
        let authStep = $('.form-with-login-or-register .step-auth[data-url-email-exists]');
    
        if (authStep.length) {
          return true;
        }
    
        return false;
      }
    }
    
    /**
     * Form income popup script
     */
     class FinHub_FormIncomesPopup {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.stepIncomesPopup = $('.incomes-popup');
    
        if (this.stepIncomesPopup.length) {
          this.initFormIncomes();
        }
      }
    
      initFormIncomes () {
        this.stepFormIncomesPopup = $('.form-incomes-popup');
        let formHelperIncomesPopup = new FinHub_FormHelper(this.stepFormIncomesPopup);
        this.addNewIncome = $('.step-income').find('.add-new-income');
        this.cancelNewIncome = this.stepIncomesPopup.find('.cancel-submit');
        this.submitPopup = this.stepFormIncomesPopup.find('.form-incomes-popup-submit');
    
        // Business activities
        let businessActivityIDs = [];
        this.stepFormIncomesPopup.find('input[name="income_type_id"][data-type="BUSINESS_ACTIVITY"]').each((i, field) => {
          businessActivityIDs.push($(field).val());
        });
    
        // Show industry
        let showIndustryIDs = [];
        this.stepFormIncomesPopup.find('input[data-show-industry="1"]').each((i, field) => {
          showIndustryIDs.push($(field).val());
        });
    
        // Show contract type
        let showContractTypeIDs = [];
        this.stepFormIncomesPopup.find('input[data-show-contract-type="1"]').each((i, field) => {
          showContractTypeIDs.push($(field).val());
        });
    
        // Show "what" fields
        let showWhatFieldIDs = [];
        this.stepFormIncomesPopup.find('input[data-show-what="1"]').each((i, field) => {
          showWhatFieldIDs.push($(field).val());
        });
    
        formHelperIncomesPopup.formDependencies([
          {
            field: 'settlement_type',
            dependsOn: 'input[name="income_type_id"]',
            showOn: (value) => businessActivityIDs.indexOf(value) > -1
          },
          {
            field: 'income_amount',
            dependsOn: 'input[name="income_type_id"]',
            showOn: (value) => businessActivityIDs.indexOf(value) === -1
          },
          {
            field: 'industry_id',
            dependsOn: 'input[name="income_type_id"]',
            showOn: (value) => showIndustryIDs.indexOf(value) > -1
          },
          {
            field: 'contract_type',
            dependsOn: 'input[name="income_type_id"]',
            showOn: (value) => showContractTypeIDs.indexOf(value) > -1
          },
          {
            field: 'income_other_name',
            dependsOn: 'input[name="income_type_id"]',
            showOn: (value) => showWhatFieldIDs.indexOf(value) > -1
          },
          {
            field: 'date_to',
            dependsOn: 'input[name="contract_type_id"], input[name="contract_type_id"]',
            showOn: () => {
              let selectedIncome = this.stepFormIncomesPopup.find('input[name="income_type_id"]:checked');
    
              if (!selectedIncome.length) {
                return false;
              }
              
              let selectedContractType = this.stepFormIncomesPopup.find('input[name="contract_type_id"]:checked');
    
              if (!selectedContractType.length) {
                let selectedIncomeType = selectedIncome.eq(0).attr('data-type');
                let selectedContractShowType = selectedIncome.eq(0).attr('data-show-contract-type');
    
                return selectedIncomeType === 'CONTRACT' && selectedContractShowType == '0';
              }
    
              let selectedIncomeType = selectedIncome.eq(0).attr('data-type');
              let selectedContractShowType = selectedIncome.eq(0).attr('data-show-contract-type');
              let selectedContractTypeShowDateTo = selectedContractType.eq(0).attr('data-show-date-to');
              
              return (
                selectedIncomeType === 'CONTRACT' && 
                selectedContractShowType == '1' && 
                selectedContractTypeShowDateTo === '1'
              ) || (
                selectedIncomeType === 'CONTRACT' &&
                selectedContractShowType == '0'
              );
            }
          },
          {
            field: 'currency',
            dependsOn: 'input[name="income_type_id"], input[name="settlement_type_id"]',
            showOn: () => {
              let incomeType = this.stepFormIncomesPopup.find('input[name="income_type_id"]:checked');
    
              if (incomeType.length && businessActivityIDs.indexOf(incomeType.eq(0).val()) === -1) {
                return true;
              }
    
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
            }
          },
          {
            field: 'revenue_amount_current_year',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
            }
          },
          {
            field: 'revenue_amount_last_year',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
            }
          },
          {
            field: 'income_amount_current_year',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER';
            }
          },
          {
            field: 'income_amount_last_year',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER';
            }
          },
          {
            field: 'billing_number_current_year',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LEDGER' || selectedSettlementType === 'LUMP_SUM';
            }
          },
          {
            field: 'tax_rate',
            dependsOn: 'input[name="settlement_type_id"]',
            showOn: () => {
              let selectedSettlement = this.stepFormIncomesPopup.find('input[name="settlement_type_id"]:checked');
    
              if (!selectedSettlement.length) {
                return false;
              }
    
              let selectedSettlementType = selectedSettlement.eq(0).attr('data-settlement-type');
              return selectedSettlementType === 'LUMP_SUM' || selectedSettlementType === 'FIXED_AMOUNT_TAX';
            }
          },      
          {
            field: 'currency_other_name',
            dependsOn: 'select[name="currency_id"]',
            showOn: () => {
              let selectedCurrency = this.stepFormIncomesPopup.find('select[name="currency_id"]').find(":selected");
    
              if (!selectedCurrency.length) {
                return false;
              }
    
              let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
              return selectedCurrencyCode === 'OTHER';
            }
          }
        ]);
    
        this.addNewIncome.on('click', e => {
          e.preventDefault();
          this.stepIncomesPopup.removeClass('is-hidden');
        });
    
        this.cancelNewIncome.on('click', e => {
          e.preventDefault();
          this.stepIncomesPopup.addClass('is-hidden');
          this.stepFormIncomesPopup[0].reset();
          $("*[data-fh-name]").addClass('is-hidden');
        });
    
        this.submitPopup.on('click', e => {
          e.preventDefault();
          let result = formHelperIncomesPopup.formValidate();
    
    			if (result) {
            let serializedData = this.stepFormIncomesPopup.serializeArray();
            serializedData = this.serializeArrayToJSON(serializedData);
            $(document).trigger('finhub-add-income', serializedData);
            this.cancelNewIncome.trigger('click');
    			}
        });
      }
    
      serializeArrayToJSON (arrayToConvert) {
        let outputJSON = {};
    
        for (let i = 0; i < arrayToConvert.length; i++) {
          let pair = arrayToConvert[i];
    
          if (pair.value === '' || pair.value === null) {
            continue;
          }
          
          outputJSON[pair.name] = pair.value;
        }
    
        return JSON.stringify(outputJSON);
      }
    }
    /**
     * Form income liabilities popup script
     */
     class FinHub_FormIncomesLiabilitiesPopup {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.stepIncomesLiabilitiesPopup = $('.incomes-liabilities-popup');
    
        if (this.stepIncomesLiabilitiesPopup.length) {
          this.initFormIncomesLiabilities();
        }
      }
    
      initFormIncomesLiabilities () {
        this.stepFormIncomesLiabilitiesPopup = $('.form-incomes-liabilities-popup');
        let formHelperIncomesLiabilitiesPopup = new FinHub_FormHelper(this.stepFormIncomesLiabilitiesPopup);
        this.addNewLiabilities = $('.step-income').find('.add-new-liabilities');
        this.cancelNewLiabilities = this.stepIncomesLiabilitiesPopup.find('.cancel-submit');
        this.submitPopup = this.stepFormIncomesLiabilitiesPopup.find('.form-incomes-liabilities-popup-submit');
        let liabilitiesWithBankIDs = [];
        this.stepFormIncomesLiabilitiesPopup.find('input[data-show-bank-select="1"]').each((i, field) => {
          liabilitiesWithBankIDs.push($(field).val());
        });
        
        formHelperIncomesLiabilitiesPopup.formDependencies([
          {
            field: 'bank_id',
            dependsOn: 'input[name="liability_id"]',
            showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
          },    
          {
            field: 'incomes-liabilities-payoff_amount_currency_name',
            dependsOn: 'select[name="incomes-liabilities-payoff_amount_currency_id"]',
            showOn: () => {
              let selectedCurrency = this.stepFormIncomesLiabilitiesPopup.find('select[name="incomes-liabilities-payoff_amount_currency_id"]').find(":selected");
    
              if (!selectedCurrency.length) {
                return false;
              }
    
              let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
              return selectedCurrencyCode === 'OTHER';
            }
          },    
          {
            field: 'incomes-liabilities-instalment_amount_currency_name',
            dependsOn: 'select[name="incomes-liabilities-instalment_amount_currency_id"]',
            showOn: () => {
              let selectedCurrency = this.stepFormIncomesLiabilitiesPopup.find('select[name="incomes-liabilities-instalment_amount_currency_id"]').find(":selected");
    
              if (!selectedCurrency.length) {
                return false;
              }
    
              let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
              return selectedCurrencyCode === 'OTHER';
            }
          }
        ]);
    
        this.cancelNewLiabilities.on('click', e => {
          e.preventDefault();
          this.stepIncomesLiabilitiesPopup.addClass('is-hidden');
          this.stepFormIncomesLiabilitiesPopup[0].reset();
          $("*[data-fh-name]").addClass('is-hidden');
        });
    
        this.submitPopup.on('click', e => {
          e.preventDefault();
          let result = formHelperIncomesLiabilitiesPopup.formValidate();
    
    			if (result) {
            let serializedData = this.stepFormIncomesLiabilitiesPopup.serializeArray();
            serializedData = this.serializeArrayToJSON(serializedData);
            let indexToUse = parseInt(this.stepIncomesLiabilitiesPopup.attr('data-index'), 10);
            $(document).trigger('finhub-add-income-liability', [serializedData, indexToUse]);
            this.cancelNewLiabilities.trigger('click');
    			}
        });
      }
    
      serializeArrayToJSON (arrayToConvert) {
        let outputJSON = {};
    
        for (let i = 0; i < arrayToConvert.length; i++) {
          let pair = arrayToConvert[i];
    
          if (pair.value === '' || pair.value === null) {
            continue;
          }
          
          outputJSON[pair.name] = pair.value;
        }
    
        return JSON.stringify(outputJSON);
      }
    }
    /**
     * Form liabilities popup script
     */
     class FinHub_FormLiabilitiesPopup {
      constructor() {
        this.initState();
      }
    
      initState() {
        this.stepLiabilitiesPopup = $('.liabilities-popup');
    
        if (this.stepLiabilitiesPopup.length) {
          this.initFormLiabilities();
        }
      }
    
      initFormLiabilities () {
        this.stepFormLiabilitiesPopup = $('.form-liabilities-popup');
        let formHelperLiabilitiesPopup = new FinHub_FormHelper(this.stepFormLiabilitiesPopup);
        this.addNewLiabilities = $('.step-liabilities').find('.add-new-liabilities');
        this.cancelNewLiabilities = this.stepLiabilitiesPopup.find('.cancel-submit');
        this.submitPopup = this.stepFormLiabilitiesPopup.find('.form-incomes-liabilities-popup-submit');
        let liabilitiesWithBankIDs = [];
        this.stepFormLiabilitiesPopup.find('input[data-show-bank-select="1"]').each((i, field) => {
          liabilitiesWithBankIDs.push($(field).val());
        });
        
        formHelperLiabilitiesPopup.formDependencies([
          {
            field: 'bank_id',
            dependsOn: 'input[name="liability_id"]',
            showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
          },
          {
            field: 'payoff_amount',
            dependsOn: 'input[name="liability_id"]',
            showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
          },
          {
            field: 'instalment_currency',
            dependsOn: 'input[name="liability_id"]',
            showOn: (value) => liabilitiesWithBankIDs.indexOf(value) > -1
          },    
          {
            field: 'incomes-liabilities-2-payoff_amount_currency_name',
            dependsOn: 'select[name="incomes-liabilities-2-payoff_amount_currency_id"]',
            showOn: () => {
              let selectedCurrency = this.stepFormLiabilitiesPopup.find('select[name="incomes-liabilities-2-payoff_amount_currency_id"]').find(":selected");
    
              if (!selectedCurrency.length) {
                return false;
              }
    
              let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
              return selectedCurrencyCode === 'OTHER';
            }
          },    
          {
            field: 'incomes-liabilities-2-instalment_amount_currency_name',
            dependsOn: 'select[name="incomes-liabilities-2-instalment_amount_currency_id"]',
            showOn: () => {
              let selectedCurrency = this.stepFormLiabilitiesPopup.find('select[name="incomes-liabilities-2-instalment_amount_currency_id"]').find(":selected");
    
              if (!selectedCurrency.length) {
                return false;
              }
    
              let selectedCurrencyCode = selectedCurrency.eq(0).attr('data-code');
              return selectedCurrencyCode === 'OTHER';
            }
          }
        ]);
    
        this.addNewLiabilities.on('click', e => {
          e.preventDefault();
          this.stepLiabilitiesPopup.removeClass('is-hidden');
        });
    
        this.cancelNewLiabilities.on('click', e => {
          if (e) {
            e.preventDefault();
          }
          
          this.stepFormLiabilitiesPopup[0].reset();
          this.stepLiabilitiesPopup.addClass('is-hidden');
          $("*[data-fh-name]").addClass('is-hidden');
        });
    
        this.submitPopup.on('click', e => {
          e.preventDefault();
          let result = formHelperLiabilitiesPopup.formValidate();
    
    			if (result) {
            let serializedData = this.stepFormLiabilitiesPopup.serializeArray();
            serializedData = this.serializeArrayToJSON(serializedData);
            $(document).trigger('finhub-add-liability', serializedData);
            this.cancelNewLiabilities.trigger('click');
    			}
        });
      }
    
      serializeArrayToJSON (arrayToConvert) {
        let outputJSON = {};
    
        for (let i = 0; i < arrayToConvert.length; i++) {
          let pair = arrayToConvert[i];
    
          if (pair.value === '' || pair.value === null) {
            continue;
          }
          
          outputJSON[pair.name] = pair.value;
        }
    
        return JSON.stringify(outputJSON);
      }
    }
    /**
     * Advisors Show List script
     */
    class FinHub_AdvisorsShowList {
        constructor() {
            this.initState();
        }
    
        initState() {
            this.advisorArchivePage = $('.advisor-archive');
            this.advisorArchiveForm = this.advisorArchivePage.find('#show-form-form');
            this.dataClick = this.advisorArchiveForm.attr('data-click');
            this.advisorArchiveFormSearchBtn = this.advisorArchiveForm.find('#search-advisers-button');
            this.advisorArchiveList = this.advisorArchivePage.find('#search-advisers-list');
            this.searchAdvisor = this.advisorArchiveForm.find('#search-advisor');
            this.searchAdvisorCity = this.advisorArchiveForm.find('#search-advisor-city');
            this.searchBottomBar = this.advisorArchiveForm.find('.bottom');
            this.searchAdvisorOnline = this.advisorArchiveForm.find('input[name="only_online"]');
            this.searchAdvisorSort = this.advisorArchiveForm.find('#sort-select');
            this.advisorArchiveRange = this.advisorArchivePage.find('.range');
            this.advisorArchiveRangeInput = this.advisorArchiveRange.find('#range-input');
            this.ratingOutput = this.advisorArchiveRange.find('.range-output');
            this.advisorArchiveRangeMinText = this.advisorArchiveRange.find('.min span');
            this.advisorArchiveRangeMaxText = this.advisorArchiveRange.find('.max span');
            this.advisorArchiveCityDesc = this.advisorArchivePage.find('#search-advisers-city-desc');
    
            if (this.advisorArchiveForm.length) {
                this.initEvents();
            }
        }
    
        getLoadedAdvisersIds() {
            let ids = [];
            $('.block-advisers__item').each((i, item) => {
                let id = $(item).attr('data-adviser-id');
                id = parseInt(id, 10);
                ids.push(id);
            });
    
            return ids;
        }
    
        initEvents() {
            this.advisorArchiveFormSearchBtn.on('click', (e) => {
                e.preventDefault();
                this.searchAdvisorOnline.prop( "checked", false );
                $('.advisor-map .map .map-overlay-button').removeClass('is-hidden');
    
                setTimeout(() => {
                    this.getAdviserResults();
                }, 0);
            });
    
            if (this.dataClick == '1') {
                this.searchAdvisorOnline.prop( "checked", false );
    
                setTimeout(() => {
                    this.getAdviserResults();
                }, 0);
            }
        }
    
        getAdviserResults () {
            this.advisorArchiveList.addClass('is-loading');
    
            $.ajax({
                url: $('#show-form-form').attr('action'),
                type: 'POST',
                dataType: 'json',
                data: jQuery.param({
                    search: this.searchAdvisor.val(),
                    city: this.searchAdvisorCity.val(),
                    only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                    sort: this.searchAdvisorSort.val()
                })
            }).done((response) => {
                this.advisorArchiveList.removeClass('is-loading');
                let uniqid = +new Date();
                this.advisorArchiveList.html(response.html + '<div id="loader-' + uniqid + '"></div>')
    
                if (response.city_html) {
                    this.advisorArchiveCityDesc.html(response.city_html)
                }
    
                if (this.searchBottomBar.hasClass('hidden')) {
                    this.searchBottomBar.removeClass('hidden');
                }
    
                this.advisorArchiveRangeInput.attr('min', parseFloat(response.min_radius));
                this.advisorArchiveRangeInput.attr('max', parseFloat(response.max_radius));
                this.advisorArchiveRangeInput.val(parseFloat(response.max_radius));
                this.advisorArchiveRangeMinText.text(response.min_radius);
                this.advisorArchiveRangeMaxText.text(response.max_radius);
                this.ratingOutput.text('');
                this.ratingOutput.css('left', 'calc(50% - 12px)');
    
                this.initRangeSlider();
                this.initCheckOnlyOnline();
                this.initChangeSelect();
    
                this.debouncedGetReloadAdviserResults = this.debounce(() => this.getReloadAdviserResults(), 750);
    
                setTimeout(() => {
                    this.infinityScroll(uniqid, response.max_items);
                }, 0);
            }).fail((response) => {
                this.advisorArchiveList.removeClass('is-loading');
            });
        }
    
        getReloadAdviserResults () {
            this.advisorArchiveList.addClass('is-loading');
    
            $.ajax({
                url: $('#show-form-form').attr('action'),
                type: 'POST',
                dataType: 'json',
                data: jQuery.param({
                    search: this.searchAdvisor.val(),
                    city: this.searchAdvisorCity.val(),
                    only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                    sort: this.searchAdvisorSort.val(),
                    radius: this.advisorArchiveRangeInput.val()
                })
            }).done((response) => {
                this.advisorArchiveList.removeClass('is-loading');
                let uniqid = +new Date();
                this.advisorArchiveList.html(response.html + '<div id="loader-' + uniqid + '"></div>')
    
                if (response.city_html) {
                    this.advisorArchiveCityDesc.html(response.city_html)
                }
    
                if (this.searchBottomBar.hasClass('hidden')) {
                    this.searchBottomBar.removeClass('hidden');
                }
    
                setTimeout(() => {
                    this.infinityScroll(uniqid, response.max_items);
                }, 0);
            }).fail((response) => {
                this.advisorArchiveList.removeClass('is-loading');
            });
        }
    
        infinityScroll(uniqid, maxItems) {
            let loadedItemsCount = this.advisorArchiveList.find('.block-advisers__item').length;
    
            if (loadedItemsCount >= maxItems) {
                return;
            }
    
            let observedElement = $('#loader-' + uniqid);
            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entries[0].intersectionRatio === 0) {
                        return;
                    }
    
                    observer.unobserve(observedElement[0]);
                    observedElement.addClass('is-loading');
                    $.ajax({
                        url: this.advisorArchiveForm.attr('action'),
                        type: 'POST',
                        dataType: 'json',
                        data: jQuery.param({
                            search: this.searchAdvisor.val(),
                            city: this.searchAdvisorCity.val(),
                            only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                            sort: this.searchAdvisorSort.val(),
                            exclude: this.getLoadedAdvisersIds(),
                            radius: this.advisorArchiveRangeInput.val()
                        })
                    }).done((response) => {
                        observedElement.removeClass('is-loading');
    
                        if (response.html) {
                            let newUniqid = +new Date();
                            this.advisorArchiveList.append($(response.html));
    
                            setTimeout(() => {
                                window.updateAdvisorsMap();
                                this.advisorArchiveList.append($('<div id="loader-' + newUniqid + '"></div>'));
                                this.infinityScroll(newUniqid, response.max_items);
                            }, 0);
                        }
                    }).fail((response) => {
                        console.log(response);
                    });
                });
            }, {
                threshold: [0.1, 0.25, 0.5, 0.75, 1]
            });
    
            observer.observe(observedElement[0]);
        }
    
        initRangeSlider () {
            this.advisorArchiveRangeInput.unbind('input');
            this.advisorArchiveRangeInput.on('input', () => {
                let ratingRangeValue = this.advisorArchiveRangeInput.val();
                let ratingMax = this.advisorArchiveRangeInput.attr('max');
                let ratingMin = this.advisorArchiveRangeInput.attr('min');
                let reatingOutputPosX = ((100 * (ratingRangeValue - ratingMin)) / (ratingMax - ratingMin));
    
                this.ratingOutput.text(ratingRangeValue);
                this.ratingOutput.css('left', 'calc(' + reatingOutputPosX + '% - 15px)');
    
                setTimeout(() => {
                    this.debouncedGetReloadAdviserResults();
                }, 0);
            });
        }
    
        initCheckOnlyOnline () {
            this.searchAdvisorOnline.unbind('input');
            this.searchAdvisorOnline.on('input', () => {
                setTimeout(() => {
                    this.debouncedGetReloadAdviserResults();
                }, 0);
            });
        }
    
        initChangeSelect () {
            this.searchAdvisorSort.unbind('change');
            this.searchAdvisorSort.on('change', () => {
                setTimeout(() => {
                    this.debouncedGetReloadAdviserResults();
                }, 0);
            });
        }
    
        debounce(func, timeout = 500) {
            let timer;
    
            return (...args) => {
              clearTimeout(timer);
              timer = setTimeout(() => { func.apply(this, args); }, timeout);
            };
        }
    }
    
    /**
     * Logotypes slider script
     */
    class FinHub_LogotypesSlider {
        constructor() {
          this.initState();
          this.initEvents();
        }
    
        initState () {
            this.brandsListWrapper = $('.logotypes');
            this.brandsSlider = $('.logotypes-slider');
            this.dotsList = this.brandsListWrapper.find('.slider-dots');
            this.dots = this.dotsList.find('.dot');
            this.prevBtn = this.brandsListWrapper.find('.prev');
            this.nextBtn = this.brandsListWrapper.find('.next');
            this.list = this.brandsSlider.find('.logotypes-list');
            this.items = this.list.find('.logotypes-item');
            this.currentItem = 0;
            this.itemsPerPage = 5;
            this.animationInProgress = false;
        }
    
        initEvents() {
            this.initRWD();
    
            if (this.brandsListWrapper.length) {
              this.initUI();
            }
          }
    
        initUI() {
          this.swipeEffect = new Hammer(this.brandsSlider[0]);
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
          this.nextBtn.on('click', (e) => {
            e.preventDefault();
            this.prevBtn.removeClass('is-hidden');
    
            if (this.animationInProgress) {
              return;
            }
    
            this.currentItem++;
    
            if (this.currentItem >= (this.items.length / this.itemsPerPage) - 1) {
              this.nextBtn.addClass('is-hidden');
            }
    
            this.animationInProgress = true;
            this.dots.removeClass('active');
            this.dots.eq(this.currentItem).addClass('active');
            this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
            setTimeout(() => {
              this.animationInProgress = false;
            }, 550);
          });
    
          this.prevBtn.on('click', (e) => {
            e.preventDefault();
            this.nextBtn.removeClass('is-hidden');
    
            if (this.animationInProgress) {
              return;
            }
    
            this.currentItem--;
    
            if (this.currentItem <= 0) {
              this.prevBtn.addClass('is-hidden');
            }
    
            this.animationInProgress = true;
            this.dots.removeClass('active');
            this.dots.eq(this.currentItem).addClass('active');
            this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
            setTimeout(() => {
              this.animationInProgress = false;
            }, 550);
          });
    
          for (let i = 0; i < this.dots.length; i++) {
            this.dots.eq(i).on('click', e => {
              e.preventDefault();
    
              if (this.animationInProgress) {
                return;
              }
    
              this.currentItem = i;
              this.animationInProgress = true;
    
              if (this.currentItem >= (this.items.length / this.itemsPerPage) - 1) {
                this.nextBtn.addClass('is-hidden');
              } else {
                this.nextBtn.removeClass('is-hidden');
              }
    
              if (this.currentItem <= 0) {
                this.prevBtn.addClass('is-hidden');
              } else {
                this.prevBtn.removeClass('is-hidden');
              }
    
              this.dots.removeClass('active');
              this.dots.eq(this.currentItem).addClass('active');
              this.list.css('margin-left', (-100 * this.currentItem) + "%");
    
              setTimeout(() => {
                this.animationInProgress = false;
              }, 550);
            });
          }
    
          this.swipeEffect.on('swipe', ev => {
            if (ev.type === 'swipe' && ev.direction === 2 && ev.deltaX < -30) {
              if (this.currentItem >= (this.items.length / this.itemsPerPage) - 1) {
                this.nextBtn.addClass('is-hidden');
                return
              } else {
                this.currentItem++;
              }
    
              this.dots.eq(this.currentItem).trigger('click');
            }
    
            if (ev.type === 'swipe' && ev.direction === 4 && ev.deltaX > 30) {
              if (this.currentItem > 0) {
                this.currentItem--;
              } else {
                this.prevBtn.addClass('is-hidden');
                return
              }
    
              this.dots.eq(this.currentItem).trigger('click');
            }
          });
        }
    
        initRWD () {
          this.desktopViewport = window.matchMedia('(min-width: 1025px)');
          this.desktopSmallViewport = window.matchMedia('(min-width: 721px) and (max-width: 1024px)');
          this.tabletViewport = window.matchMedia('(min-width: 561px) and (max-width: 720px)');
          this.mobileViewport = window.matchMedia('(max-width: 560px)');
          if (this.desktopViewport.matches) this.updateViewports('desktop');
          if (this.desktopSmallViewport.matches) this.updateViewports('desktopSmall');
          if (this.tabletViewport.matches) this.updateViewports('tablet');
          if (this.mobileViewport.matches) this.updateViewports('mobile');
          this.desktopViewport.addListener(mq => mq.matches ? this.updateViewports('desktop') : false);
          this.desktopSmallViewport.addListener(mq => mq.matches ? this.updateViewports('desktopSmall') : false);
          this.tabletViewport.addListener(mq => mq.matches ? this.updateViewports('tablet') : false);
          this.mobileViewport.addListener(mq => mq.matches ? this.updateViewports('mobile') : false);
    
          if (this.desktopViewport.matches) {
            this.itemsPerPage = 5;
          } else if (this.desktopSmallViewport.matches) {
            this.itemsPerPage = 4;
          } else if (this.tabletViewport.matches) {
            this.itemsPerPage = 3;
          } else if (this.mobileViewport.matches) {
            this.itemsPerPage = 2;
          }
    
          this.toggleDotsVisibility();
    
          this.desktopViewport.addListener(mq => {
            if (mq.matches) {
              this.setItemsPerPage(5);
            }
          });
    
          this.desktopSmallViewport.addListener(mq => {
            if (mq.matches) {
              this.setItemsPerPage(4);
            }
          });
    
          this.tabletViewport.addListener(mq => {
            if (mq.matches) {
              this.setItemsPerPage(3);
            }
          });
    
          this.mobileViewport.addListener(mq => {
            if (mq.matches) {
              this.setItemsPerPage(2);
            }
          });
        }
    
        updateViewports (type) {
          if (this.currentViewport !== type) {
            this.currentItem = 0;
            this.list.css('margin-left', "0%");
            this.currentViewport = type;
          }
        }
    
        setItemsPerPage (numberOfItems) {
          this.currentItem = 0;
          this.itemsPerPage = numberOfItems;
          this.dots.removeClass('active');
          this.dots.eq(this.currentItem).addClass('active');
          this.list.css('margin-left', (-100 * this.currentItem) + "%");
          this.toggleDotsVisibility();
        }
    
        toggleDotsVisibility () {
          let visibleDots = Math.ceil((this.items.length / this.itemsPerPage) - 1);
    
          for (let i = 0; i < this.dots.length; i++) {
            let visibilityState = i <= visibleDots ? 'block' : 'none';
            this.dots.eq(i).css('display', visibilityState);
          }
    
          if (this.items.length - this.itemsPerPage <= 0) {
            this.dotsList.css('display', 'none');
          } else {
            this.dotsList.css('display', 'flex');
          }
        }
      }
    

    new FinHub_FormHelper();
    new FinHub_Menu();
    new FinHub_Tabs();
    new FinHub_AdvisersSlider();
    new FinHub_SocialSharing();
    new FinHub_UI();
    new FinHub_AdvisorsSingleMap();
    new FinHub_AdvisorsArchiveMap();
    new FinHub_FormStepsAdvisorChoose();
    new FinHub_FormStepsCompareOffer();
    new FinHub_FormStepsConsultation();
    new FinHub_FormIncomesPopup();
    new FinHub_FormIncomesLiabilitiesPopup();
    new FinHub_FormLiabilitiesPopup();
    new FinHub_AdvisorsShowList();
    new FinHub_LogotypesSlider();

    // init datepickers
    $.fn.datepicker.languages['pl-PL'] = {
        format: 'YYYY-mm-dd',
        days: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
        daysShort: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        // Used and correct are only daysShort, daysMin are just shorted to fit UI
        daysMin: ['Nie', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
        weekStart: 1,
        months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru']
    };

    $('[data-toggle="datepicker"]').datepicker({
        language: 'pl-PL',
        autoHide: true
    });

    $('#contact-customer_post_code[data-fh-validation="required|postcode"').mask('00-000');
})(jQuery);
